import { Component, useState, useEffect } from 'react'
import { Redirect } from "react-router-dom"
import { WidthProvider, Responsive } from "react-grid-layout"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { SupervisorioLinkForm } from './Elementos/Link'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import PlantaBaixa from './PlantaBaixa'
import { Link } from 'react-router-dom'
import Select from '../../components/Select'
import { v4 as uuidv4 } from 'uuid'

import Reservatorio from './Elementos/Reservatorio'
import GraficoBarra from './Elementos/GraficoBarra'
import GraficoLinha from './Elementos/GraficoLinha'
import MaximoAtual from './Elementos/MaximoAtual'
import arrowLeft from '../../assets/svg/arrow_left.svg'
import Imagem from './Elementos/Imagem'
import Poco from './Elementos/Poco'
import ValorAtual from './Elementos/ValorAtual'
import ValorAtualV2 from './Elementos/ValorAtualV2'
import Status from './Elementos/Status'
import VolumeDia from './Elementos/VolumeDia'
import Comando from './Elementos/Comando'
import helper from '../../utils/helper'
import ReservatorioV2 from './Elementos/ReservatorioV2/index.js'
import ListaAlertas from './Elementos/ListaAlertas/index.js'
import GraficoGauge from './Elementos/Gauge.js'

import { io } from "socket.io-client"
import auth from '../../utils/auth'
import moment from 'moment'
import axios from 'axios'
import cfg from '../../utils/config'
import './style.css'
import tourManager from '../../tours/TourManager'

import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

const ResponsiveReactGridLayout = WidthProvider(Responsive)

const TOUR_DEMO_EVENT = 'hdv-tour-supervisorio-demo'
const TOUR_DEMO_WIDGET_ID = 'hdv-tour-demo-widget'
const TOUR_DEMO_SUPERVISORIO_ID = 'hdv-tour-demo-supervisorio'
const TOUR_DEMO_EQUIPAMENTO = 'hdv-tour-imei'
const TOUR_DEMO_CAMPO_ID = 'hdv_tour_exemplo'
const TOUR_DEMO_MONITORADO = { id: 'hdv-tour-demo-monitorado', nome: 'Monitorado de exemplo' }
const TOUR_DEMO_CAMPO = {
    id: TOUR_DEMO_CAMPO_ID,
    label: 'Temperatura (exemplo)',
    value: 'hdv-tour-demo-campo',
    dataType: 'text',
    equipamento: { imei: TOUR_DEMO_EQUIPAMENTO, usuario_mqtt: 'hdv_tour_mqtt' },
}
const TOUR_DEMO_WIDGET = {
    id: TOUR_DEMO_WIDGET_ID,
    type: '2',
    descricao: encodeURI('Valor atual de exemplo'),
    equipamento: TOUR_DEMO_EQUIPAMENTO,
    mqtt: 'hdv_tour_mqtt',
    campo: TOUR_DEMO_CAMPO_ID,
    calcularVolume: false,
    parametros: {
        valor_normal: 30,
        valor_alerta: 35,
        valor_perigo: 40,
        icone: 'fa-thermometer-half',
        minutos_alerta_semcomunicacao: 30,
    },
}

let tourDemoRuntime = {
    injected: false,
    snapshot: null,
    applyTourDemo: null,
    restoreTourDemo: null,
}

const cloneValue = (value) => {
    try {
        return JSON.parse(JSON.stringify(value ?? null))
    } catch (error) {
        return value
    }
}

const RESERVATORIO_V2_TYPE = '12'
const RESERVATORIO_V2_GRID = { w: 3, h: 8, minW: 2, minH: 6, maxW: 8, maxH: 22 }
const SUPERVISORIO_GRID = { cols: 12, rowHeight: 30, marginX: 10, marginY: 10 }
const RESERVATORIO_TANK_ASPECT = 604 / 882.338
const RESERVATORIO_CHROME_Y = 52
const RESERVATORIO_PAD_X = 16
const RESERVATORIO_VISUAL_GAP = 4
const RESERVATORIO_SCALE_MIN_PX = 76
const RESERVATORIO_SCALE_MAX_PX = 176
const RESERVATORIO_SCALE_CQW = 0.28

const clampGridSize = (value, min, max) => Math.max(min, Math.min(max, Math.round(value)))

const getSupervisorioGridWidth = (node) => {
    const fromNode = node?.closest?.('.react-grid-layout')?.clientWidth
    if (fromNode) return fromNode
    if (typeof document !== 'undefined') {
        const fromDom = document.querySelector('.hdv-bodysuper .react-grid-layout')?.clientWidth
        if (fromDom) return fromDom
    }
    return 1200
}

const reservatorioColWidth = (containerWidth) => (
    (containerWidth - SUPERVISORIO_GRID.marginX * (SUPERVISORIO_GRID.cols - 1)) / SUPERVISORIO_GRID.cols
)

const reservatorioPixelWidth = (w, containerWidth) => {
    const colWidth = reservatorioColWidth(containerWidth)
    return w * colWidth + Math.max(0, w - 1) * SUPERVISORIO_GRID.marginX
}

const reservatorioPixelHeight = (h) => (
    h * SUPERVISORIO_GRID.rowHeight + Math.max(0, h - 1) * SUPERVISORIO_GRID.marginY
)

const reservatorioScaleWidth = (visualW) => (
    Math.min(RESERVATORIO_SCALE_MAX_PX, Math.max(RESERVATORIO_SCALE_MIN_PX, visualW * RESERVATORIO_SCALE_CQW))
)

const reservatorioHeightFromWidthPx = (pxW) => {
    const visualW = Math.max(1, pxW - RESERVATORIO_PAD_X)
    const tankW = Math.max(1, visualW - RESERVATORIO_VISUAL_GAP - reservatorioScaleWidth(visualW))
    return tankW / RESERVATORIO_TANK_ASPECT + RESERVATORIO_CHROME_Y
}

const reservatorioWidthFromHeightPx = (pxH) => {
    const visualH = Math.max(1, pxH - RESERVATORIO_CHROME_Y)
    const tankW = visualH * RESERVATORIO_TANK_ASPECT
    const visualFromScale = (scale) => tankW + RESERVATORIO_VISUAL_GAP + scale
    const candidates = [
        visualFromScale(RESERVATORIO_SCALE_MIN_PX),
        visualFromScale(0) / (1 - RESERVATORIO_SCALE_CQW),
        visualFromScale(RESERVATORIO_SCALE_MAX_PX),
    ]

    let visualW = candidates[1]
    let best = Infinity
    candidates.forEach((candidate) => {
        const next = visualFromScale(reservatorioScaleWidth(candidate))
        const error = Math.abs(next - candidate)
        if (error < best) {
            best = error
            visualW = next
        }
    })

    return visualW + RESERVATORIO_PAD_X
}

const sizeReservatorioV2FromWidth = (width, containerWidth, allowFallback = true) => {
    const { minW, minH, maxW, maxH } = RESERVATORIO_V2_GRID
    const w = clampGridSize(width, minW, maxW)
    const pxH = reservatorioHeightFromWidthPx(reservatorioPixelWidth(w, containerWidth))
    const hRaw = (pxH + SUPERVISORIO_GRID.marginY) / (SUPERVISORIO_GRID.rowHeight + SUPERVISORIO_GRID.marginY)
    if (allowFallback && hRaw > maxH) return sizeReservatorioV2FromHeight(maxH, containerWidth, false)
    if (allowFallback && hRaw < minH) return sizeReservatorioV2FromHeight(minH, containerWidth, false)
    return { w, h: clampGridSize(hRaw, minH, maxH) }
}

const sizeReservatorioV2FromHeight = (height, containerWidth, allowFallback = true) => {
    const { minW, minH, maxW, maxH } = RESERVATORIO_V2_GRID
    const h = clampGridSize(height, minH, maxH)
    const pxW = reservatorioWidthFromHeightPx(reservatorioPixelHeight(h))
    const colWidth = reservatorioColWidth(containerWidth)
    const wRaw = (pxW + SUPERVISORIO_GRID.marginX) / (colWidth + SUPERVISORIO_GRID.marginX)
    if (allowFallback && wRaw > maxW) return sizeReservatorioV2FromWidth(maxW, containerWidth, false)
    if (allowFallback && wRaw < minW) return sizeReservatorioV2FromWidth(minW, containerWidth, false)
    return { w: clampGridSize(wRaw, minW, maxW), h }
}

const fitReservatorioV2Size = (oldItem, newItem, containerWidth) => {
    const prevW = oldItem?.w ?? newItem.w
    const prevH = oldItem?.h ?? newItem.h
    const deltaW = Math.abs(reservatorioPixelWidth(newItem.w, containerWidth) - reservatorioPixelWidth(prevW, containerWidth))
    const deltaH = Math.abs(reservatorioPixelHeight(newItem.h) - reservatorioPixelHeight(prevH))
    if (deltaW >= deltaH) return sizeReservatorioV2FromWidth(newItem.w, containerWidth)
    return sizeReservatorioV2FromHeight(newItem.h, containerWidth)
}

const snapReservatorioV2Item = (item, containerWidth) => {
    const fromW = sizeReservatorioV2FromWidth(item.w, containerWidth)
    const fromH = sizeReservatorioV2FromHeight(item.h, containerWidth)
    const errorW = Math.abs(fromW.w - item.w) + Math.abs(fromW.h - item.h)
    const errorH = Math.abs(fromH.w - item.w) + Math.abs(fromH.h - item.h)
    const size = errorW <= errorH ? fromW : fromH
    return {
        ...item,
        ...size,
        minW: RESERVATORIO_V2_GRID.minW,
        minH: RESERVATORIO_V2_GRID.minH,
        maxW: RESERVATORIO_V2_GRID.maxW,
        maxH: RESERVATORIO_V2_GRID.maxH,
    }
}

const isReservatorioV2LayoutItem = (widgets, itemId) => (
    (widgets || []).some((widget) => String(widget.id) === String(itemId) && String(widget.type) === RESERVATORIO_V2_TYPE)
)

const DEMO_RESERVATORIO_LAYOUT_ID = 'demo-reservatorio-v2'

const packDemoSupervisorioLayoutItems = (items, containerWidth) => {
    if (!Array.isArray(items)) return items

    const reservoir = items.find((item) => item?.i === DEMO_RESERVATORIO_LAYOUT_ID)
    if (!reservoir) return items

    const next = items.map((item) => ({ ...item }))
    const byId = (id) => next.find((item) => item.i === id)
    const packedReservoir = byId(DEMO_RESERVATORIO_LAYOUT_ID)
    const size = sizeReservatorioV2FromWidth(3, containerWidth)
    const resH = Math.max(8, size.h || 8)

    packedReservoir.x = 0
    packedReservoir.y = 0
    packedReservoir.w = 3
    packedReservoir.h = resH
    packedReservoir.minW = RESERVATORIO_V2_GRID.minW
    packedReservoir.minH = RESERVATORIO_V2_GRID.minH
    packedReservoir.maxW = RESERVATORIO_V2_GRID.maxW
    packedReservoir.maxH = RESERVATORIO_V2_GRID.maxH

    const gauge = byId('demo-gauge-energia')
    if (gauge) {
        gauge.x = 3
        gauge.y = 0
        gauge.w = 3
        gauge.h = resH
    }

    const rowH = Math.max(4, Math.floor(resH / 2))
    const valores = [
        { id: 'demo-valor-atual-temperatura', x: 6, y: 0, h: rowH },
        { id: 'demo-valor-atual-vazao', x: 6, y: rowH, h: resH - rowH },
        { id: 'demo-valor-atual-volume', x: 9, y: 0, h: rowH },
        { id: 'demo-valor-atual-horas', x: 9, y: rowH, h: resH - rowH },
    ]

    valores.forEach(({ id, x, y, h }) => {
        const item = byId(id)
        if (!item) return
        item.x = x
        item.y = y
        item.w = 3
        item.h = Math.max(4, h)
    })

    const poco = byId('demo-poco-nivel')
    const linha = byId('demo-linha-nivel')
    const barra = byId('demo-barra-volume')
    if (poco) {
        poco.x = 0
        poco.y = resH
        poco.w = 3
        poco.h = 12
    }
    if (linha) {
        linha.x = 3
        linha.y = resH
        linha.w = 5
        linha.h = 12
    }
    if (barra) {
        barra.x = 8
        barra.y = resH
        barra.w = 4
        barra.h = 12
    }

    return next
}

const applyReservatorioV2LayoutMins = (layouts, widgets, packDemo = true) => {
    if (!layouts || typeof layouts !== 'object' || Array.isArray(layouts)) return layouts

    const ids = new Set(
        (widgets || [])
            .filter((widget) => String(widget?.type) === RESERVATORIO_V2_TYPE)
            .map((widget) => String(widget.id))
    )
    if (!ids.size) return layouts

    const containerWidth = getSupervisorioGridWidth()
    const next = {}
    Object.keys(layouts).forEach((breakpoint) => {
        const items = layouts[breakpoint]
        if (!Array.isArray(items)) {
            next[breakpoint] = items
            return
        }

        const snapped = items.map((item) => {
            if (!ids.has(String(item?.i))) return item
            if (packDemo && item?.i === DEMO_RESERVATORIO_LAYOUT_ID) return item
            return snapReservatorioV2Item(item, containerWidth)
        })

        next[breakpoint] = packDemo
            ? packDemoSupervisorioLayoutItems(snapped, containerWidth)
            : snapped
    })

    return next
}

const parseSupervisorioLayouts = (layoutJson, widgets) => {
    let layouts = []
    try {
        layouts = layoutJson ? JSON.parse(layoutJson) : []
    } catch (err) {
        layouts = []
    }
    return applyReservatorioV2LayoutMins(layouts, widgets)
}

const isSupervisorioGuidePending = () => {
    if (tourManager.activeTourName === 'supervisorio') return true

    try {
        return tourManager.getMinimizedState()?.tourName === 'supervisorio'
    } catch (error) {
        return false
    }
}

export const isSupervisorioTourDemoWidget = (widget) => widget?.id === TOUR_DEMO_WIDGET_ID

export const hasSupervisorioTourDemoWidgets = (widgets) => (widgets || []).some(isSupervisorioTourDemoWidget)

export const isSupervisorioTourDemoInjected = () => Boolean(tourDemoRuntime.injected)

const hasRealWidgets = (widgets) => (widgets || []).some((widget) => !isSupervisorioTourDemoWidget(widget))

const buildTourDemoEquipamentosData = () => ({
    [TOUR_DEMO_EQUIPAMENTO]: {
        [TOUR_DEMO_CAMPO_ID]: 24.5,
        unidades: { [TOUR_DEMO_CAMPO_ID]: '°C' },
        timestamp_dispositivo: Math.floor(Date.now() / 1000),
        id_dispositivo: TOUR_DEMO_EQUIPAMENTO,
    },
})

const buildTourDemoSupervisorio = () => ({
    id: TOUR_DEMO_SUPERVISORIO_ID,
    descricao: 'Supervisório de exemplo',
    widgets: JSON.stringify([TOUR_DEMO_WIDGET]),
    layout: JSON.stringify({
        lg: [{ i: TOUR_DEMO_WIDGET_ID, x: 0, y: 0, w: 3, h: 4, minW: 3, minH: 4 }],
    }),
    tipo: 'empresa',
    cliente: null,
})

export const restoreSupervisorioTourDemo = () => {
    if (typeof tourDemoRuntime.restoreTourDemo === 'function') {
        tourDemoRuntime.restoreTourDemo()
        return
    }

    if (!tourDemoRuntime.injected && !tourDemoRuntime.snapshot) return

    tourDemoRuntime.injected = false
    tourDemoRuntime.snapshot = null
}

class Supervisorio extends Component {
    userInfo = auth.getUserInfo()
    configMe = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

    state = {
        isComponenteIsolado: false,
        socket: null,
        coresConfig: {
            "degrade_top_primeira_cor": "#F44E3B", "degrade_top_segunda_cor": "#2f577b",
            "back_logomarca": "#37424A", "back_menu_lateral": "#37424A", "fonte_menu_lateral": "#c7c7c7",
            "fonte_grupo_menu_lateral": "#c7c7c7"
        },
        modal: { supervisorio: false, delete: false, apresentacao: false, edit: false, widget: false, compartilhar: false, erro: false },
        opacity: 0,
        logomarca: '',
        layouts: JSON.parse(localStorage.getItem('layouts')),
        gaugeRef: { h: 150 },
        apresentacao: { index: 0, function: null, intervalo: { label: '30 Segundos', value: 30_000 } },
        novoSupervisorio: { descricao: false, tipo: "empresa", cliente_id: false },
        supervisorios: [],
        supervisorioSelecionado: false,
        editEnabled: false,
        clientes: [],
        novoWidget: { id_widget: false, descricao_widget: false, equipamento: false, campo: false, calcularVolume: false, parametros: false },
        widgets: [],
        monitorados: [],
        equipamentosVinculados: [],
        equipamentosData: {},
        camposDisponiveis: [],
        comandos: [],
        comandosDisponiveis: [],
        htmlCampos: [],
        redirect: { to: null },
        needUpdate: false,
        blockScreen: false,
        socketReconnectInterval: null,
        showIcons: false,
        widgetEdit: { input: "", widget: null, element: null },
        compartilhar: { descricao: "", expiraEm: "", link: "", erros: [] },
        tab: 0,
        tourDemoInjected: false,
        tourSeletorMenuAberto: null,
        modal_referencias: false,
        key_edit_referencia: null,
        referencias: {
            detalhes: { parametro: "", cor: "#000000" },
            validacao: { parametro: true, cor: true }
        },
        widgetsDisponiveis: [
            {
                id: 1, descricao: "Reservatório (%)", parametros: [
                    { field: "valor_maximo", label: "Valor Máximo", type: "float", optional: false },
                    { field: "minutos_alerta_semcomunicacao", label: "Alerta de Comunicação Atrasada (em minutos)", type: "float", optional: false }
                ]
            }, {
                id: 2, descricao: "Valor Atual", parametros: [
                    { field: "valor_normal", label: "Valor Normal", type: "float", optional: true },
                    { field: "valor_alerta", label: "Valor Alerta", type: "float", optional: true },
                    { field: "valor_perigo", label: "Valor Perigoso", type: "float", optional: true },
                    { field: "icone", label: "Icone", type: "text", optional: true, fn: () => this.showSelectedIcons() },
                    { field: "minutos_alerta_semcomunicacao", label: "Alerta de Comunicação Atrasada (em minutos)", type: "float", optional: false }
                ]
            }, {
                id: 3, descricao: "Imagem", disabled: true, parametros: [
                    { field: "image", label: "Selecionar Imagem", type: "file", optional: false }
                ]
            }, {
                id: 4, descricao: "Valor Máximo x Atual", parametros: [
                    { field: "valor_maximo", label: "Valor Máximo", type: "float", optional: false },
                    { field: "valor_alerta", label: "Valor Alerta", type: "float", optional: false },
                    { field: "minutos_alerta_semcomunicacao", label: "Alerta de Comunicação Atrasada (em minutos)", type: "float", optional: false }
                    /*{field: "referencias", label: "Referências", type: "array", array_fields: [{field: "descricao", label: "Descrição", type: "text"}, {field: "valor", label: "Valor", type: "float"}], optional: false}*/
                ]
            }, {
                id: 5, descricao: "Poço", parametros: [
                    { field: "instalacao_bomba", label: "Instalação da Bomba (metros)", type: "float", optional: false },
                    { field: "instalacao_sensor", label: "Instalação do Sensor (metros)", type: "float", optional: false },
                    { field: "nivel_estatico", label: "Nível Estático (metros)", type: "float", optional: false },
                    { field: "campo_vazao", label: "Vazão", type: "custom_field", optional: false },
                    { field: "minutos_alerta_semcomunicacao", label: "Alerta de Comunicação Atrasada (em minutos)", type: "float", optional: false }
                ]
            }, {
                id: 6, descricao: "Gráfico de Linhas",
                parametros: [
                    { field: "valor_minimo", label: "Valor Minimo", type: "float", optional: true },
                    { field: "valor_maximo", label: "Valor Máximo", type: "float", optional: true },
                    { field: "valores_anteriores", label: "Mostrar valores anteriores", type: "checkbox", optional: true },
                    { field: "periodo", label: "Período de exibição", type: "select_field", optional: true },
                    { field: "minutos_alerta_semcomunicacao", label: "Alerta de Comunicação Atrasada (em minutos)", type: "float", optional: false },
                    { field: "referencias", label: "Linhas de referência", type: "button_referencia", optional: false }
                ]
            }, {
                id: 7, descricao: "Gráfico de Barras",
                parametros: [
                    { field: "periodo", label: "Período de exibição", type: "select_field", optional: true },
                    { field: "valores_anteriores", label: "Mostrar valores anteriores", type: "checkbox", optional: true },
                    { field: "minutos_alerta_semcomunicacao", label: "Alerta de Comunicação Atrasada (em minutos)", type: "float", optional: false }
                ]
            }, {
                id: 8, descricao: "Status", parametros: [
                    { field: "on", label: "Descrição Ligado", type: "text", optional: false },
                    { field: "off", label: "Descrição Desligado", type: "text", optional: false },
                    { field: "minutos_alerta_semcomunicacao", label: "Alerta de Comunicação Atrasada (em minutos)", type: "float", optional: false }
                ]
            }, {
                id: 9, descricao: "Volume Diário", parametros: [
                    { field: "minutos_alerta_semcomunicacao", label: "Alerta de Comunicação Atrasada (em minutos)", type: "float", optional: false }
                ]
            }, {
                id: 10, descricao: "Valor Atual v2", parametros: [
                    { field: "valor_normal", label: "Valor Normal", type: "float_between", optional: true },
                    { field: "valor_alerta", label: "Valor Alerta", type: "float_between", optional: true },
                    { field: "valor_perigo", label: "Valor Perigoso", type: "float_between", optional: true },
                    { field: "icone", label: "Icone", type: "text", optional: true, fn: () => this.showSelectedIcons() },
                    { field: "minutos_alerta_semcomunicacao", label: "Alerta de Comunicação Atrasada (em minutos)", type: "float", optional: false }
                ]
            }, {
                id: 11, descricao: "Comando", parametros: [
                    { field: "comandos", label: "Selecione o comando", type: "select_field", optional: false }
                ]
            }, {
                id: 12, descricao: "Reservatório v2", parametros: [
                    { field: "valor_altura", label: "Altura do reservatório (metros)", type: "float", optional: false },
                    { field: "valor_normal", label: "Valor mínimo normal (%)", type: "float_between", optional: false },
                    { field: "label_normal", label: "Texto da badge Normal (opcional)", type: "text", optional: true, placeholder: "Normal" },
                    { field: "valor_alerta", label: "Valor mínimo alerta (%)", type: "float_between", optional: false },
                    { field: "label_alerta", label: "Texto da badge Alerta (opcional)", type: "text", optional: true, placeholder: "Alerta" },
                    { field: "valor_perigo", label: "Valor mínimo perigoso (%)", type: "float_between", optional: false },
                    { field: "label_perigo", label: "Texto da badge Perigoso (opcional)", type: "text", optional: true, placeholder: "Perigoso" },
                    { field: "minutos_alerta_semcomunicacao", label: "Alerta de Comunicação Atrasada (em minutos)", type: "float", optional: false }
                ]
            }, {
                id: 13, descricao: "Lista de Alertas", parametros: [
                    { field: "limit", label: "Quantidade de alertas", type: "float", optional: false },
                    { field: "intervalo", label: "Atualizar lista de alertas a cada (em minutos)", type: "float", optional: false }
                ], isComponenteIsolado: true
            }, {
                id: 14, descricao: "Gráfico Gauge", parametros: [
                    { field: "tipo_gauge", label: "Tipo do Gauge", type: "select_field", optional: false },
                    { field: "inverter", label: "Inverter Valores", type: "checkbox", optional: true },
                    { field: "valor_maximo", label: "Valor Máximo Esperado", type: "float", optional: false },
                    { field: "valor_normal", label: "Faixa Normal (mínimo até máximo)", type: "float_between", optional: true },
                    { field: "valor_alerta", label: "Faixa Alerta (mínimo até máximo)", type: "float_between", optional: true },
                    { field: "valor_perigo", label: "Faixa Perigoso (mínimo até máximo)", type: "float_between", optional: true },
                    { field: "minutos_alerta_semcomunicacao", label: "Alerta de Comunicação Atrasada (em minutos)", type: "float", optional: false }
                ]
            }
        ],
    }

    sortSupervisories() {
        let supervisorios = []

        if (this.state.supervisorios?.length > 0) {
            this.state.supervisorios?.sort((a, b) => {
                if (a.descricao < b.descricao) return -1
                if (a.descricao > b.descricao) return 1
                return 0
            })?.forEach(supervisorio => {
                supervisorios.push({ label: supervisorio.descricao, value: supervisorio.id, supervisorio })
            })
        }

        return supervisorios
    }

    toggleApresentacao = () => {
        let { apresentacao, supervisorios } = this.state

        if (apresentacao.function === null) {
            apresentacao.function = setInterval(() => {
                apresentacao.index += 1

                if (apresentacao.index === supervisorios.length)
                    apresentacao.index = 0

                this.selectSupervisory(supervisorios[apresentacao.index].id)
            }, apresentacao.intervalo.value)

            this.setState({ apresentacao })
            setTimeout(() => this.handleModal("apresentacao"), 5_000)
        } else {
            window.clearInterval(this.state.apresentacao.function)
            apresentacao.function = null
            this.setState({ apresentacao })
        }
    }

    handleModal = (key, autoClose = false) => {
        let modal = this.state.modal
        modal[key] = !modal[key]
        this.setState({ modal })

        if (autoClose) {
            setTimeout(() => {
                modal[key] = false
                this.setState({ modal })
            }, 4500)
        }
    }

    componentDidMount = () => {
        document.addEventListener(TOUR_DEMO_EVENT, this.handleTourDemo)
        tourDemoRuntime.applyTourDemo = this.applyTourDemo
        tourDemoRuntime.restoreTourDemo = this.restoreTourDemo

        if (tourDemoRuntime.injected) {
            this.setState({ tourDemoInjected: true })
        }
    }

    handleTourDemo = (event) => {
        const action = event.detail?.action
        if (action === 'snapshot') this.captureTourDemoSnapshot()
        if (action === 'apply') this.applyTourDemo()
        if (action === 'apply-shell') this.applyTourDemoShell()
        if (action === 'restore') this.restoreTourDemo()
        if (action === 'open-selector') this.setState({ tourSeletorMenuAberto: true })
        if (action === 'close-selector') {
            this.setState({ tourSeletorMenuAberto: false })
            setTimeout(() => this.setState({ tourSeletorMenuAberto: null }), 350)
        }
        if (action === 'ensure-select-options') this.ensureTourSelectOptions()
        if (action === 'select-valor-atual') {
            const tipoSelect = document.querySelector('[data-tour="supervisorio-widget-tipo"]')
            if (tipoSelect) tipoSelect.value = '2'
            this.showWidgetParams({ target: { id: 'id_widget', value: '2' } })
        }
        if (action === 'set-edit-enabled') this.setState({ editEnabled: Boolean(event.detail?.enabled) })
        if (action === 'open-edit') this.openTourEditModal()
        if (action === 'set-create-tipo') this.newSupervisory({ target: { id: 'tipo', value: event.detail?.tipo || 'empresa' } })
        if (action === 'set-tab') this.setState({ tab: Number(event.detail?.tab) === 1 ? 1 : 0 })
    }

    isTourDemoPersistenciaBloqueada = () => {
        return tourDemoRuntime.injected || hasSupervisorioTourDemoWidgets(this.state.widgets) || this.state.supervisorioSelecionado?.id === TOUR_DEMO_SUPERVISORIO_ID
    }

    openTourEditModal = () => {
        const widgets = this.state.widgets || []
        const widget = widgets.find((item) => item.id === TOUR_DEMO_WIDGET_ID) || widgets[0]
        if (!widget) return

        let widgetDescricao = widget.descricao
        try {
            widgetDescricao = decodeURI(widgetDescricao)
        } catch (error) {
            widgetDescricao = widget.descricao
        }

        this.setState({
            editEnabled: true,
            modal: { ...this.state.modal, edit: true },
            widgetEdit: {
                widget,
                element: document.querySelector('[data-tour="supervisorio-widget-menu"]')?.parentElement?.querySelector('span') || null,
                input: widgetDescricao,
            },
        })
    }

    ensureTourSelectOptions = () => {
        const monitorados = this.state.monitorados?.length > 0 ? this.state.monitorados : [TOUR_DEMO_MONITORADO]
        const camposDisponiveis = this.state.camposDisponiveis?.length > 0 ? this.state.camposDisponiveis : [TOUR_DEMO_CAMPO]
        this.setState({ monitorados, camposDisponiveis })
    }

    captureTourDemoSnapshot = () => {
        if (tourDemoRuntime.snapshot) return

        tourDemoRuntime.snapshot = {
            supervisorioSelecionado: cloneValue(this.state.supervisorioSelecionado),
            widgets: cloneValue(this.state.widgets || []),
            layouts: cloneValue(this.state.layouts),
            equipamentosData: cloneValue(this.state.equipamentosData || {}),
            editEnabled: this.state.editEnabled,
        }
    }

    applyTourDemoShell = () => {
        if (hasSupervisorioTourDemoWidgets(this.state.widgets)) return
        if (this.state.supervisorioSelecionado?.id === TOUR_DEMO_SUPERVISORIO_ID) return

        this.captureTourDemoSnapshot()

        const supervisorioSelecionado = Object.assign({}, buildTourDemoSupervisorio(), {
            widgets: JSON.stringify([]),
            layout: JSON.stringify({}),
        })

        tourDemoRuntime.injected = true
        tourDemoRuntime.applyTourDemo = this.applyTourDemo
        tourDemoRuntime.restoreTourDemo = this.restoreTourDemo

        this.setState({
            tourDemoInjected: true,
            supervisorioSelecionado,
            widgets: [],
            layouts: {},
            editEnabled: false,
        })
    }

    applyTourDemo = () => {
        if (hasSupervisorioTourDemoWidgets(this.state.widgets)) return

        this.captureTourDemoSnapshot()

        const equipamentosData = Object.assign({}, this.state.equipamentosData || {}, buildTourDemoEquipamentosData())
        const demoLayouts = { lg: [{ i: TOUR_DEMO_WIDGET_ID, x: 0, y: 0, w: 3, h: 4, minW: 3, minH: 4 }] }
        const supervisorioSelecionado = Object.assign({}, buildTourDemoSupervisorio(), {
            widgets: JSON.stringify([TOUR_DEMO_WIDGET]),
            layout: JSON.stringify(demoLayouts),
        })

        tourDemoRuntime.injected = true
        tourDemoRuntime.applyTourDemo = this.applyTourDemo
        tourDemoRuntime.restoreTourDemo = this.restoreTourDemo

        this.setState({
            tourDemoInjected: true,
            supervisorioSelecionado,
            widgets: [TOUR_DEMO_WIDGET],
            equipamentosData,
            layouts: demoLayouts,
            editEnabled: this.state.supervisorioSelecionado?.id === TOUR_DEMO_SUPERVISORIO_ID
                ? this.state.editEnabled
                : false,
        })
    }

    restoreTourDemo = () => {
        const snapshot = tourDemoRuntime.snapshot
        if (!snapshot && !this.state.tourDemoInjected && !tourDemoRuntime.injected) return

        tourDemoRuntime.injected = false
        tourDemoRuntime.snapshot = null

        if (!snapshot) {
            this.setState({ tourDemoInjected: false, tourSeletorMenuAberto: null })
            return
        }

        this.setState({
            tourDemoInjected: false,
            tourSeletorMenuAberto: null,
            supervisorioSelecionado: snapshot.supervisorioSelecionado,
            widgets: snapshot.widgets || [],
            layouts: snapshot.layouts,
            equipamentosData: snapshot.equipamentosData || {},
            editEnabled: snapshot.editEnabled,
        })
    }

    showSelectedIcons = () => {
        this.setState({ blockScreen: true, showIcons: true })
    }

    componentWillMount = () => {
        if (this.props.shared) {
            let { supervisorio } = this.props.link

            let coresConfig = { "degrade_top_primeira_cor": "#F44E3B", "degrade_top_segunda_cor": "#2f577b", "back_logomarca": "#37424A", "back_menu_lateral": "#37424A", "fonte_menu_lateral": "#c7c7c7", "fonte_grupo_menu_lateral": "#c7c7c7" }
            let logomarca = ''
            let supervisorios = [supervisorio]
            let clientes = []

            this.setState({ opacity: 1, coresConfig, logomarca, clientes, supervisorios })
            setTimeout(() => this.selectSupervisory(supervisorio.id), 200)
        } else {
            let requestArray = []
            let userInfo = auth.getUserInfo()
            let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

            if (!userInfo?.empresa) return

            requestArray.push(axios.get(cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/configuracao-cores/', config_me))
            requestArray.push(axios.get(cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/configuracao-sistema/', config_me))
            requestArray.push(axios.get(cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/supervisorio/?limit=1000', config_me))
            requestArray.push(axios.get(cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/cliente/', config_me))

            axios.all(requestArray).then(axios.spread((coresConfig, config, supervisorios, clientes) => {
                let cores = { "degrade_top_primeira_cor": "#F44E3B", "degrade_top_segunda_cor": "#2f577b", "back_logomarca": "#37424A", "back_menu_lateral": "#37424A", "fonte_menu_lateral": "#c7c7c7", "fonte_grupo_menu_lateral": "#c7c7c7" }
                let logomarca = ''
                let supervisoriosLista = []
                let clientesLista = []

                if (coresConfig.status === 200) {
                    cores = coresConfig.data?.results?.[0]

                    let cssVars = document.querySelector(':root')
                    cssVars.style.setProperty('--degrade_top_primeira_cor', cores?.degrade_top_primeira_cor)
                    cssVars.style.setProperty('--fonte_menu_lateral', cores?.fonte_menu_lateral)
                    cssVars.style.setProperty('--background-menu', cores?.back_menu_lateral)
                    cssVars.style.setProperty('--fonte_grupo_menu_lateral', cores?.fonte_grupo_menu_lateral)
                    cssVars.style.setProperty('--fonte_titulo_abas', cores?.degrade_top_primeira_cor)
                }

                if (config.status === 200) {
                    logomarca = config.data?.results?.[0]?.logomarca
                }

                if (supervisorios.status === 200) {
                    supervisoriosLista = supervisorios.data?.results
                }

                if (clientes.status === 200) {
                    clientesLista = clientes.data.results
                }

                this.setState({ coresConfig: cores, opacity: 1, logomarca, supervisorios: supervisoriosLista, clientes: clientesLista })
            }))
        }
    }

    startSocket = (data) => {
        let options = {
            reconnectionDelayMax: 10000,
            auth: {
                apiVersion: cfg.api_v2,
                token: this.props.hash ? this.props.hash : auth.getToken(),
                type: this.props.hash ? "hash" : "token"
            }
        }

        const socket = this.state.socket ?? io("https://skt.afira.io/", options)

        // const socket = this.state.socket ?? io("http://10.0.0.6:4000/", options)

        socket.on("connect", () => {
            console.info("[connected]")
            
            socket.emit("join.supervisory", data)
        })

        socket.on("update", (_data) => {
            let time = (new Date()).toLocaleTimeString().slice(0, 5)
            console.info(`[${time}][updating]`, _data)

            let { equipamentosData, supervisorioSelecionado } = this.state
            let mqttToImei = {}

            try {
                JSON.parse(supervisorioSelecionado.widgets)?.map((widget) => {
                    mqttToImei[widget.mqtt] = widget.equipamento

                    const referencias = widget?.parametros?.referencias ?? []
                    if(referencias.length > 0) {
                        referencias.forEach((referencia) => {
                            mqttToImei[referencia.parametro.equipamento.usuario_mqtt] = referencia.parametro.equipamento.imei
                        })
                    }
                })

                const id = mqttToImei[_data?.reporte?.id_dispositivo]
                this.setState({ updating: true })

                if (equipamentosData?.[id]) {
                    for (let key of Object.keys(_data?.reporte)) {
                        equipamentosData[id][key] = _data?.reporte[key]
                    }
                    this.setState({ equipamentosData })
                }

                setTimeout(() => this.setState({ updating: false }), 5_000)
            } catch (err) {
                console.error(err)
            }
        })

        //socket.on("disconnect", () => this.socketReconnection(data))

        document.addEventListener("beforeunload", (e) => socket.disconnect())
        document.addEventListener("__force_disconnect", (e) => {
            console.info("[disconnected]")
            socket.disconnect()
        })

        this.setState({ socket: socket })
    }

    socketReconnection = (data) => {
        const socketReconnectInterval = setInterval(() => {
            if (this.state.socket && this.state.socket?.connected === false) {
                this.startSocket(data)
            } else {
                clearInterval(this.state.socketReconnectInterval)
                clearInterval(socketReconnectInterval)
            }
        }, 20_000)

        this.setState({ socketReconnectInterval })
    }

    componentWillUnmount = () => {
        document.removeEventListener(TOUR_DEMO_EVENT, this.handleTourDemo)

        if (!isSupervisorioGuidePending() && (this.state.tourDemoInjected || tourDemoRuntime.injected)) {
            this.restoreTourDemo()
        }

        if (tourDemoRuntime.restoreTourDemo === this.restoreTourDemo) {
            tourDemoRuntime.applyTourDemo = null
            tourDemoRuntime.restoreTourDemo = null
        }

        clearInterval(this.state.apresentacao.function)
        clearInterval(this.state.socketReconnectInterval)
        this.state.socket?.disconnect()
    }

    newSupervisory = (e) => {
        let newObj = this.state.novoSupervisorio
        if (e.target.value === "") {
            newObj[e.target.id] = false
        } else {
            newObj[e.target.id] = e.target.value
        }
        this.setState({ novoSupervisorio: newObj })
    }

    saveSupervisory = () => {
        let { novoSupervisorio } = this.state
        let userInfo = auth.getUserInfo()
        let bodyFormData = new FormData()
        const configMe = { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() } }

        if (!Boolean(novoSupervisorio.descricao)) return

        if (userInfo?.tipo == "cliente") {
            bodyFormData.append("cliente_id", userInfo.cliente)
            bodyFormData.append("descricao", novoSupervisorio?.descricao)
            bodyFormData.append("tipo", "cliente")
        } else {
            if (novoSupervisorio?.tipo == "cliente") {
                if (novoSupervisorio?.cliente_id) {
                    bodyFormData.append("cliente_id", novoSupervisorio?.cliente_id)
                }
                else return
            }

            bodyFormData.append("descricao", novoSupervisorio?.descricao)
            bodyFormData.append("tipo", novoSupervisorio?.tipo)
        }

        axios({
            method: 'POST',
            url: cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/supervisorio/',
            data: bodyFormData,
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        }).then((res) => {
            let url = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/supervisorio/?limit=1000'

            helper.dispatchEvent("showAviso", {
                message: "Supervisório criado com sucesso!",
                callback: null
            })

            axios.get(url, configMe).then((res) => {
                this.setState({ supervisorios: res.data?.results, supervisorioSelecionado: false, widgets: [] })
            })
        }).catch(console.error)
    }

    getMonitorados = () => {
        let userInfo = auth.getUserInfo()
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }
        let requestURL = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/monitorado?limit=100/'

        axios.get(requestURL, config_me).then((res) => {
            let monitorados = res.data?.results?.length > 0 ? res.data?.results : []
            try {
                monitorados = monitorados?.sort((a, b) => {
                    let textA = a?.nome.toUpperCase()
                    let textB = b?.nome.toUpperCase()
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                })
            } catch (err) {
                console.error(err)
            }

            this.setState({ monitorados: monitorados })

            if (isSupervisorioGuidePending() && monitorados.length === 0) {
                this.setState({ monitorados: [TOUR_DEMO_MONITORADO], camposDisponiveis: [TOUR_DEMO_CAMPO] })
            }
        }).catch(() => {
            if (isSupervisorioGuidePending()) {
                this.setState({ monitorados: [TOUR_DEMO_MONITORADO], camposDisponiveis: [TOUR_DEMO_CAMPO] })
            }
        })
    }

    selectSupervisory = async (e) => {
        const supId = isNaN(e) ? Number(e.target.value) : Number(e)

        if (supId === this.state.supervisorioSelecionado.id) return

        this.setState({ supervisorioSelecionado: false, tab: 0 })

        if (this.state.socket) {
            document.dispatchEvent(new CustomEvent('__force_disconnect'))
            this.setState({ socket: null })
            await new Promise((r, _) => setTimeout(() => r(), 100))
        }

        let supervisory = false
        let userInfo = auth.getUserInfo()
        let configMe = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }
        clearInterval(this.state.socketReconnectInterval)

        if (supId) {
            supervisory = this.state.supervisorios.find((sup) => sup.id === supId)
        }

        if (!supervisory) {
            this.setState({ supervisorioSelecionado: false, widgets: [] })
            return
        }

        this.setState({ blockScreen: true })

        let parsed = JSON.parse(supervisory.widgets || "[]")
        let widgets = Array.isArray(parsed) ? parsed : []
        let user = { id: userInfo?.id, type: userInfo?.tipo, name: userInfo?.nome }
        let vinculados = []
        let mqttKeys = []

        widgets?.forEach((widget) => {
            if (widget?.equipamento)
                vinculados.push(widget.equipamento)
            if (widget?.mqtt)
                mqttKeys.push(widget.mqtt)

            // adicionando equipamentos vinculados e mqttkeys dos parâmetros que são linhas de referências.
            let referencias = widget?.parametros?.referencias ?? []
            if (referencias.length > 0) {
                referencias.forEach((referencia) => {
                    vinculados.push(referencia.parametro.equipamento.imei)
                    mqttKeys.push(referencia.parametro.equipamento.usuario_mqtt)
                })
            }
        })

        vinculados = Array.from(new Set(vinculados))
        mqttKeys = Array.from(new Set(mqttKeys))

        if (this.props.shared) {
            this.setState({
                blockScreen: false,
                needUpdate: false,
                supervisorioSelecionado: supervisory,
                equipamentosData: supervisory.reportes,
                widgets: widgets,
                layouts: parseSupervisorioLayouts(supervisory.layout, widgets)
            })

            this.startSocket({
                supervisory,
                devices: mqttKeys,
                user,
            })
        } else {
            this.getComandos()
            this.startSocket({ supervisory, devices: mqttKeys, user, company: userInfo.empresa })

            let bodyFormData = new FormData()
            bodyFormData.append("equipamentos", JSON.stringify(vinculados))

            axios.post(cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/reporte/supervisorio/', bodyFormData, configMe)
                .then((res) => {
                    let data = res.data
                    let { apresentacao } = this.state
                    const layouts = parseSupervisorioLayouts(supervisory.layout, widgets)
                    apresentacao.index = this.state.supervisorios.indexOf(supervisory)

                    for (let key of Object.keys(data)) {
                        data[key].unidades = {}

                        if ("_parametros" in data[key]) {
                            data[key]._parametros?.forEach((param) => {
                                if ("unidade" in param) {
                                    data[key].unidades[param.identificacao] = param.unidade
                                }
                            })
                        }
                    }

                    this.setState({
                        blockScreen: false, equipamentosData: data, equipamentosVinculados: vinculados, needUpdate: false,
                        supervisorioSelecionado: supervisory, apresentacao, widgets, layouts
                    })
                })
                .catch((err) => {
                    console.error(err)
                    const layouts = parseSupervisorioLayouts(supervisory.layout, widgets)
                    this.setState({ blockScreen: false, widgets: [], supervisorioSelecionado: false, layouts })
                    this.handleModal("erro", true)
                })
        }
    }

    getComandos = () => {
        let requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/comando-customizado/'

        axios.get(requestURL, this.configMe).then((res) => {
            let comandos = res.data?.results ?? []
            this.setState({ comandos })
        })
    }

    filterComandos = (equipamento = null, campo = null) => {
        let comandos = this.state.comandos

        if (equipamento) {
            comandos = comandos.filter((cmd) => cmd?.equipamento__imei == equipamento)
        } else {
            comandos = []
        }

        this.setState({ comandosDisponiveis: comandos })
        return comandos
    }

    updateSupervisory = () => {
        this.setState({ needUpdate: true })
    }

    actionUpdateSupervisory = () => {
        if (this.isTourDemoPersistenciaBloqueada()) return

        let supervisorioSelecionado = this.state.supervisorioSelecionado
        let userInfo = auth.getUserInfo()
        let bodyFormData = new FormData()
        const configMe = { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() } }

        for (let key in supervisorioSelecionado) {
            if (supervisorioSelecionado[key] !== 'cliente__nome_fantasia' && supervisorioSelecionado[key] !== 'id')
                bodyFormData.append(key, supervisorioSelecionado[key])
        }

        if (Boolean(supervisorioSelecionado.cliente)) {
            bodyFormData.set('cliente', String(supervisorioSelecionado.cliente))
        } else {
            bodyFormData.delete('cliente')
        }

        axios({
            method: 'PATCH',
            url: cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/supervisorio/' + supervisorioSelecionado.id + '/',
            data: bodyFormData,
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        })
            .then(() => {
                axios.get(cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/supervisorio/?limit=1000', configMe).then((res) => {
                    this.setState({ supervisorios: res.data?.results, needUpdate: false })
                })
            })
            .catch(console.error)
    }

    deleteSupervisory = () => {
        if (this.isTourDemoPersistenciaBloqueada()) return

        let userInfo = auth.getUserInfo()
        let bodyFormData = new FormData()
        const configMe = { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() } }

        axios({
            method: 'DELETE',
            url: cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/supervisorio/' + this.state.supervisorioSelecionado.id + '/',
            data: bodyFormData,
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        }).then(() => {
            axios.get(cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/supervisorio/', configMe).then((res) => {

                this.setState({ supervisorios: res.data?.results, supervisorioSelecionado: false, widgets: [] })
            })
        })
            .catch((error) => console.error(error))
    }

    newWidget = (e) => {
        let newObj = this.state.novoWidget
        let { camposDisponiveis } = this.state

        if (e.target.value === "") {
            newObj[e.target.id] = false
        } else {
            let value = e.target.value
            if (e.target.id === "campo") {
                let campo = camposDisponiveis.find(campo => campo.value == e.target.value)

                if (campo) {
                    newObj.equipamento = campo?.equipamento?.imei
                    newObj.equipamento_mqtt = campo?.equipamento?.usuario_mqtt
                    value = campo.id
                }
            }

            newObj[e.target.id] = value
        }

        this.setState({ novoWidget: newObj })

        if (e.target.id == "campo") {
            if (newObj?.equipamento) {
                this.showWidgetParams({ target: { value: "11" } })
            }
        }

        setTimeout(() => this.setState({ blockScreen: false }), 2000)
    }

    deleteWidget = (id) => {
        if (this.isTourDemoPersistenciaBloqueada()) return

        let widgets = this.state.widgets
        let supervisorioSelecionado = this.state.supervisorioSelecionado
        let widgets_novo = widgets.filter((widget) => widget.id !== id)
        supervisorioSelecionado['widgets'] = JSON.stringify(widgets_novo)
        this.setState({ widgets: widgets_novo, supervisorioSelecionado: supervisorioSelecionado })
        this.handleModal("edit")
    }

    saveWidget = () => {
        if (this.isTourDemoPersistenciaBloqueada()) return

        let widgets = this.state.widgets
        let supervisorioSelecionado = this.state.supervisorioSelecionado
        const widgetSelecionado = this.state.widgetEdit
        let widgetIndex = widgets.findIndex((w) => w.id === widgetSelecionado.widget.id)
        widgets[widgetIndex].descricao = this.state.widgetEdit.input.trim()
        widgetSelecionado.element.innerHTML = this.state.widgetEdit.input.trim()
        supervisorioSelecionado['widgets'] = JSON.stringify(widgets)

        this.actionUpdateSupervisory()
        this.handleModal("edit")
    }

    getMonitoradoFields = async (e) => {
        let userInfo = auth.getUserInfo()
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

        if (!e.target.value) return

        if (String(e.target.value) === String(TOUR_DEMO_MONITORADO.id)) {
            this.setState({ camposDisponiveis: [TOUR_DEMO_CAMPO] })
            return
        }

        document.querySelector(".hdv-barsuper-select#campo").value = ""

        let requestArray = [
            axios.get(cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/monitorado-parametro/?monitorado=${e.target.value}&limit=100`, config_me),
            axios.get(cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/monitorado-comando/?monitorado=${e.target.value}&limit=100`, config_me)
        ]

        let comandosDisponiveis = []
        let camposDisponiveis = []

        await axios.all(requestArray).then(axios.spread((params, comandos) => {
            params?.data?.results?.forEach((field) => {
                let campo = field?.campo

                camposDisponiveis.push({
                    id: campo?.identificacao,
                    label: `${campo.descricao} (${campo.identificacao})`,
                    value: campo.id,
                    dataType: "text",
                    equipamento: campo?.equipamento,
                })
            })

            comandos?.data?.results?.forEach((item) => {
                comandosDisponiveis.push(item?.comando)
            })

        }))

        this.setState({ camposDisponiveis, comandosDisponiveis })
        setTimeout(() => {
            this.showWidgetParams({ target: { value: "11" } })
        }, 150)
    }

    showWidgetParams = (e) => {
        let newObj = this.state.novoWidget
        let { comandosDisponiveis } = this.state

        try {
            if (e?.target?.value === "") {
                newObj[e.target.id] = false
            } else {
                newObj[e.target.id] = e.target.value
            }
        } catch (err) {
            console.error(err)
        }

        let selectWidget = this.state.widgetsDisponiveis.filter((widget) => widget.id === parseInt(e.target.value))[0]
        let tipoGaugeAtual = newObj?.parametros?.tipo_gauge

        const camposDependentesDoTipoGauge = ["inverter", "valor_maximo", "valor_normal", "valor_alerta", "valor_perigo", "minutos_alerta_semcomunicacao"]
        let parametrosVisiveis = selectWidget?.parametros?.filter((field) => {
            if (selectWidget?.id !== 14) return true
            if (field.field === "inverter") return tipoGaugeAtual === "absoluto"
            if (!camposDependentesDoTipoGauge.includes(field.field)) return true
            return !!tipoGaugeAtual
        })

        let fields = parametrosVisiveis?.map((field, key) => {
            let options = []
            let label = field.label

            if (selectWidget?.id === 14) {
                const isPercentual = tipoGaugeAtual === "percentual"
                if (field.field === "valor_maximo") {
                    label = "Valor Máximo Esperado (decimal ou inteiro)"
                } else if (field.field === "valor_normal") {
                    label = isPercentual ? "Faixa Normal (% mínimo até % máximo)" : "Faixa Normal (mínimo até máximo)"
                } else if (field.field === "valor_alerta") {
                    label = isPercentual ? "Faixa Alerta (% mínimo até % máximo)" : "Faixa Alerta (mínimo até máximo)"
                } else if (field.field === "valor_perigo") {
                    label = isPercentual ? "Faixa Perigoso (% mínimo até % máximo)" : "Faixa Perigoso (mínimo até máximo)"
                }
            }

            if (field.field == "periodo") {
                options.push(<option key={Math.random()} value="1">1 Hora</option>)
                options.push(<option key={Math.random()} value="3">3 Horas</option>)
                options.push(<option key={Math.random()} value="6">6 Horas</option>)
                options.push(<option key={Math.random()} value="12">12 Horas</option>)
                options.push(<option key={Math.random()} value="24">24 Horas</option>)
            } else if (field.field == "comandos") {
                comandosDisponiveis.forEach((comando, key) => {
                    options.push(<option key={"c-" + key} value={comando.id}>{comando.descricao}</option>)
                })
            } else if (field.field == "campo_vazao") {
                let { camposDisponiveis } = this.state
                camposDisponiveis.forEach((campo, key) => {
                    options.push(<option key={"cd-" + key} value={campo.id}>{campo.label}</option>)
                })
            } else if (field.field == "tipo_gauge") {
                options.push(<option key="gauge-abs" value="absoluto">Valor Absoluto</option>)
                options.push(<option key="gauge-pct" value="percentual">Porcentagem</option>)
            } else {
                let { camposDisponiveis } = this.state
                camposDisponiveis.forEach((campo, key) => {
                    options.push(<option key={"cd-" + key} value={campo.value}>{campo.label}</option>)
                })
            }

            switch (field.type) {
                case 'file':
                    return (
                        <div key={key}>
                            <label className={(key === 0) ? "hdv-barsuper-label" : "hdv-barsuper-label hdv-barsuper-label-margin"} htmlFor={field.field}>{field.label}</label>
                            <input onChange={this.saveSubParamField} type="file" className="hdv-barsuper-input" id={field.field} name={field.field} />
                        </div>
                    )
                case 'select_field':
                    return (
                        <div key={key}>
                            <label className={(key === 0) ? "hdv-barsuper-label" : "hdv-barsuper-label hdv-barsuper-label-margin"} htmlFor={field.field}>{label}</label>
                            <select
                                onChange={field.field === "tipo_gauge" ? this.onChangeTipoGauge : this.saveSubParamField}
                                id={field.field} name={field.field} className="hdv-barsuper-select"
                                defaultValue={newObj?.parametros?.[field.field] || ""}
                            >
                                <option value="">-- Selecione --</option>
                                {options}
                            </select>
                        </div>
                    )
                case 'custom_field':
                    return (
                        <div key={key}>
                            <label className={(key === 0) ? "hdv-barsuper-label" : "hdv-barsuper-label hdv-barsuper-label-margin"} htmlFor={field.field}>{field.label}</label>
                            <input type="text" value={newObj?.campo ?? ""} readOnly id={field.field} name={field.field} className="hdv-barsuper-input" />
                        </div>
                    )
                case 'checkbox':
                    return (
                        <div key={key}>
                            <label className={(key === 0) ? "hdv-barsuper-label" : "hdv-barsuper-label hdv-barsuper-label-margin"} htmlFor={field.field}>
                                {label}
                                <input type="checkbox" onChange={this.saveSubParamField} id={field.field} name={field.field} className="hdv-barsuper-select" />
                            </label>
                        </div>
                    )
                case 'float_between':
                    return (
                        <div key={key}>
                            <label className={(key === 0) ? "hdv-barsuper-label" : "hdv-barsuper-label hdv-barsuper-label-margin"} htmlFor={field.field}>{label}</label>
                            <input onChange={(e) => this.saveSubParamBetween(field.field, "min", e.target.value)} type="text" className="hdv-barsuper-input" id={field.field} name={field.field} />
                            &nbsp; Até &nbsp;
                            <input onChange={(e) => this.saveSubParamBetween(field.field, "max", e.target.value)} type="text" className="hdv-barsuper-input" id={field.field} name={field.field} />
                        </div>
                    )
                case 'button_referencia': 
                    return (
                        <div key={key}>
                            <button className='hdv-btn-forms hdv-btn-blue w-100 mt-3' onClick={() => this.toggleModalReferencias(true)}>{field.label}</button>
                        </div>
                    )
                default:
                    return (
                        <div key={key} data-tour={`supervisorio-widget-${field.field.replace(/_/g, '-')}`}>
                            <label className={(key === 0) ? "hdv-barsuper-label" : "hdv-barsuper-label hdv-barsuper-label-margin"} htmlFor={field.field}>{label}</label>
                            {
                                ("fn" in field)
                                    ?
                                    <input onClick={field.fn} onChange={this.saveSubParamField} type="text" className="hdv-barsuper-input" id={field.field} name={field.field} />
                                    :
                                    <input onChange={this.saveSubParamField} type="text" className="hdv-barsuper-input" id={field.field} name={field.field} placeholder={field.placeholder || ""} />
                            }
                        </div>
                    )
            }
        })

        newObj['parametros'] = {}
        selectWidget?.parametros.forEach((field, key) => {
            newObj['parametros'][field.field] = field.field === "referencias" ? [] : false
        })

        let isComponenteIsolado = selectWidget?.isComponenteIsolado

        this.setState({ novoWidget: newObj, htmlCampos: fields, isComponenteIsolado: isComponenteIsolado })
    }

    toggleEdit = () => {
        this.setState({ editEnabled: !this.state.editEnabled })
        document.querySelector('details.hdv-super-popup').open = false
    }

    onChangeTipoGauge = (e) => {
        let newObj = this.state.novoWidget
        if (e.target.value === "") {
            newObj.parametros[e.target.id] = false
        } else {
            newObj.parametros[e.target.id] = e.target.value
        }

        let selectWidget = this.state.widgetsDisponiveis.find((widget) => widget.id === parseInt(newObj.id_widget))
        let tipoGaugeAtual = e.target.value || false
        let parametrosVisiveis = selectWidget?.parametros?.filter((field) => {
            if (field.field === "inverter") return tipoGaugeAtual === "absoluto"
            return true
        })

        let fields = parametrosVisiveis?.map((field, key) => {
            let options = []
            let label = field.label

            if (selectWidget?.id === 14) {
                const isPercentual = tipoGaugeAtual === "percentual"
                if (field.field === "valor_maximo") {
                    label = "Valor Máximo Esperado (decimal ou inteiro)"
                } else if (field.field === "valor_normal") {
                    label = isPercentual ? "Faixa Normal (% mínimo até % máximo)" : "Faixa Normal (mínimo até máximo)"
                } else if (field.field === "valor_alerta") {
                    label = isPercentual ? "Faixa Alerta (% mínimo até % máximo)" : "Faixa Alerta (mínimo até máximo)"
                } else if (field.field === "valor_perigo") {
                    label = isPercentual ? "Faixa Perigoso (% mínimo até % máximo)" : "Faixa Perigoso (mínimo até máximo)"
                }
            }

            if (field.field === "tipo_gauge") {
                options.push(<option key="gauge-abs" value="absoluto">Valor Absoluto</option>)
                options.push(<option key="gauge-pct" value="percentual">Porcentagem</option>)
            }

            switch (field.type) {
                case 'select_field':
                    return (
                        <div key={key}>
                            <label className={(key === 0) ? "hdv-barsuper-label" : "hdv-barsuper-label hdv-barsuper-label-margin"} htmlFor={field.field}>{label}</label>
                            <select
                                onChange={field.field === "tipo_gauge" ? this.onChangeTipoGauge : this.saveSubParamField}
                                id={field.field} name={field.field} className="hdv-barsuper-select"
                                defaultValue={newObj?.parametros?.[field.field] || ""}
                            >
                                <option value="">-- Selecione --</option>
                                {options}
                            </select>
                        </div>
                    )
                case 'checkbox':
                    return (
                        <div key={key}>
                            <label className={(key === 0) ? "hdv-barsuper-label" : "hdv-barsuper-label hdv-barsuper-label-margin"} htmlFor={field.field}>
                                {label}
                                <input type="checkbox" onChange={this.saveSubParamField} id={field.field} name={field.field} className="hdv-barsuper-select" defaultChecked={!!newObj?.parametros?.[field.field]} />
                            </label>
                        </div>
                    )
                case 'float_between':
                    return (
                        <div key={key}>
                            <label className={(key === 0) ? "hdv-barsuper-label" : "hdv-barsuper-label hdv-barsuper-label-margin"} htmlFor={field.field}>{label}</label>
                            <input onChange={(e) => this.saveSubParamBetween(field.field, "min", e.target.value)} type="text" className="hdv-barsuper-input" id={field.field} name={field.field} defaultValue={newObj?.parametros?.[field.field]?.min || ""} />
                            &nbsp; Até &nbsp;
                            <input onChange={(e) => this.saveSubParamBetween(field.field, "max", e.target.value)} type="text" className="hdv-barsuper-input" id={field.field} name={field.field} defaultValue={newObj?.parametros?.[field.field]?.max || ""} />
                        </div>
                    )
                default:
                    return (
                        <div key={key}>
                            <label className={(key === 0) ? "hdv-barsuper-label" : "hdv-barsuper-label hdv-barsuper-label-margin"} htmlFor={field.field}>{label}</label>
                            <input onChange={this.saveSubParamField} type="text" className="hdv-barsuper-input" id={field.field} name={field.field} defaultValue={newObj?.parametros?.[field.field] || ""} />
                        </div>
                    )
            }
        })

        this.setState({ novoWidget: newObj, htmlCampos: fields })
    }

    showEditParams = () => {
        let { widgetEdit, modal, comandosDisponiveis, camposDisponiveis, isComponenteIsolado } = this.state
        if (!modal.edit) return

        let parametros = widgetEdit.widget.parametros
        let selectWidget = this.state.widgetsDisponiveis.find((widget) => widget.id === parseInt(widgetEdit.widget.type))
        let tipoGaugeAtual = parametros?.tipo_gauge

        const camposDependentesDoTipoGauge = ["inverter", "valor_maximo", "valor_normal", "valor_alerta", "valor_perigo", "minutos_alerta_semcomunicacao"]
        let parametrosVisiveis = selectWidget?.parametros?.filter((field) => {
            if (selectWidget?.id !== 14) return true
            if (field.field === "inverter") return tipoGaugeAtual === "absoluto"
            if (!camposDependentesDoTipoGauge.includes(field.field)) return true
            return !!tipoGaugeAtual
        })

        let fields = parametrosVisiveis?.map((field, key) => {
            let value = (field.field in parametros && parametros[field.field] !== false) ? parametros[field.field] : ""
            let options = []
            let label = field.label

            if (selectWidget?.id === 14) {
                const isPercentual = tipoGaugeAtual === "percentual"
                if (field.field === "valor_maximo") {
                    label = "Valor Máximo Esperado (decimal ou inteiro)"
                } else if (field.field === "valor_normal") {
                    label = isPercentual ? "Faixa Normal (% mínimo até % máximo)" : "Faixa Normal (mínimo até máximo)"
                } else if (field.field === "valor_alerta") {
                    label = isPercentual ? "Faixa Alerta (% mínimo até % máximo)" : "Faixa Alerta (mínimo até máximo)"
                } else if (field.field === "valor_perigo") {
                    label = isPercentual ? "Faixa Perigoso (% mínimo até % máximo)" : "Faixa Perigoso (mínimo até máximo)"
                }
            }

            if (field.field == "periodo") {
                options.push(<option key={Math.random()} value="1">1 Hora</option>)
                options.push(<option key={Math.random()} value="3">3 Horas</option>)
                options.push(<option key={Math.random()} value="6">6 Horas</option>)
            } else if (field.field == "comandos") {
                options = []

                comandosDisponiveis.filter((comando) => {
                    return comando.equipamento__imei == widgetEdit.equipamento
                }).forEach((comando, key) => {
                    options.push(<option key={"c-" + key} value={comando.id}>{comando.descricao}</option>)
                })
            } if (field.field == "campo_vazao") {
                camposDisponiveis.forEach((campo, key) => {
                    options.push(<option key={"cd-" + key} value={campo.id}>{campo.label}</option>)
                })
            } else if (field.field == "tipo_gauge") {
                options.push(<option key="gauge-abs" value="absoluto">Valor Absoluto</option>)
                options.push(<option key="gauge-pct" value="percentual">Porcentagem</option>)
            } else {
                this.state.camposDisponiveis.forEach((campo, key) => {
                    options.push(<option key={"cd-" + key} value={campo.value}>{campo.label}</option>)
                })
            }

            switch (field.type) {
                case 'file':
                    return (
                        <div key={key}>
                            <label className={(key === 0) ? "hdv-barsuper-label" : "hdv-barsuper-label hdv-barsuper-label-margin"} htmlFor={field.field}>{field.label}</label>
                            <input onChange={(e) => this.saveSubParamField(e, true)} type="file" className="hdv-barsuper-input" id={field.field} name={field.field} value={value} />
                        </div>
                    )
                case 'checkbox':
                    return (
                        <div key={key}>
                            <label className={(key === 0) ? "hdv-barsuper-label" : "hdv-barsuper-label hdv-barsuper-label-margin"} htmlFor={field.field}>
                                {label}
                                <input onChange={(e) => this.saveSubParamField(e, true)} type="checkbox" id={field.field} name={field.field} className="hdv-barsuper-select" checked={!!parametros[field.field]} />
                            </label>
                        </div>
                    )
                case 'select_field':
                    return (
                        <div key={key}>
                            <label className={(key === 0) ? "hdv-barsuper-label" : "hdv-barsuper-label hdv-barsuper-label-margin"} htmlFor={field.field}>{label}</label>
                            <select
                                value={field.field == "comandos" ? this.state.widgetEdit.widget.parametros.comandos : value}
                                onChange={(e) => this.saveSubParamField(e, true)}
                                id={field.field} name={field.field}
                                className="hdv-barsuper-select">
                                <option value="">-- Selecione --</option>
                                {options}
                            </select>
                        </div>
                    )
                case 'custom_field':
                    if (this.state.monitorados.length == 0) {
                        this.getMonitorados()
                    }

                    return (
                        <div className="row" key={key}>
                            <div className="col-md-6" style={{ display: isComponenteIsolado ? "none" : "block" }}>
                                <label className="hdv-barsuper-label hdv-barsuper-label-margin" htmlFor="monitorado">Selecione o Monitorado</label>
                                <select onChange={this.getMonitoradoFields} id="monitorado" name="monitorado" className="hdv-barsuper-select">
                                    <option value="">-- Monitorados --</option>
                                    {
                                        this.state.monitorados.map((monitorado, key) => {
                                            return <option key={key} value={monitorado.id}>{monitorado.nome}</option>
                                        })
                                    }
                                </select>
                            </div>
                            <div className="col-md-6">
                                <label className={(key === 0) ? "hdv-barsuper-label" : "hdv-barsuper-label hdv-barsuper-label-margin"} htmlFor={field.field}>{label}</label>
                                <select
                                    value={field.field == "comandos" ? this.state.widgetEdit.widget.parametros.comandos : value}
                                    onChange={(e) => this.saveSubParamField(e, true)} id={field.field} name={field.field}
                                    className="hdv-barsuper-select">
                                    <option value="">-- Selecione --</option>
                                    {options}
                                </select>
                            </div>
                        </div>
                    )
                case 'float_between':
                    return (
                        <div key={key}>
                            <label className={(key === 0) ? "hdv-barsuper-label" : "hdv-barsuper-label hdv-barsuper-label-margin"} htmlFor={field.field}>{label}</label>
                            <input onChange={(e) => this.saveSubParamBetween(field.field, "min", e.target.value, true)} type="text" className="hdv-barsuper-input" id={field.field} name={field.field} value={value?.min} />
                            &nbsp; Até &nbsp;
                            <input onChange={(e) => this.saveSubParamBetween(field.field, "max", e.target.value, true)} type="text" className="hdv-barsuper-input" id={field.field} name={field.field} value={value?.max} />
                        </div>
                    )
                case 'button_referencia':
                    return
                default:
                    return (
                        <div key={key}>
                            <label className={(key === 0) ? "hdv-barsuper-label" : "hdv-barsuper-label hdv-barsuper-label-margin"} htmlFor={field.field}>{label}</label>
                            {("fn" in field)
                                ?
                                <div className="sup-icone" onClick={field.fn}>
                                    <input onChange={(e) => this.saveSubParamField(e, true)} type="text" className="hdv-barsuper-input" id={field.field} name={field.field} value={value} />
                                    <span className={`fa ${value} fa-2x`}></span>
                                </div>
                                :
                                <input onChange={(e) => this.saveSubParamField(e, true)} type="text" className="hdv-barsuper-input" id={field.field} name={field.field} value={value} placeholder={field.placeholder || ""} />
                            }
                        </div>
                    )
            }
        }) ?? []

        return fields
    }

    saveSubParamField = (e, edit = false) => {
        let widgetEdit = this.state.widgetEdit
        let newObj = edit ? this.state.widgetEdit.widget : this.state.novoWidget

        if (e.target.type == "checkbox") {
            newObj.parametros[e.target.id] = e.target.checked
        } else {
            newObj.parametros[e.target.id] = e.target.value === "" ? "" : e.target.value
        }

        if (edit) {
            widgetEdit.widget = newObj
            document.querySelector(`#${e.target.id}`).value = e.target.value
            this.setState({ widgetEdit: widgetEdit })
        } else {
            this.setState({ novoWidget: newObj })
        }
    }

    saveSubParamBetween = (field, ref, value, edit = false) => {
        let widgetEdit = this.state.widgetEdit
        let newObj = edit ? this.state.widgetEdit.widget : this.state.novoWidget

        if (typeof (newObj.parametros[field]) !== 'object')
            newObj.parametros[field] = {}

        newObj.parametros[field][ref] = value === "" ? "" : value

        if (edit) {
            widgetEdit.widget = newObj
            this.setState({ widgetEdit: widgetEdit })
        } else {
            this.setState({ novoWidget: newObj })
        }
    }

    saveSubParamIcon = (e) => {
        let editing = this.state.modal.edit
        let widgetEdit = this.state.widgetEdit
        let newObj = editing ? this.state.widgetEdit.widget : this.state.novoWidget

        document.getElementById('icone').value = e.target.id

        if (e.target.id === "") {
            newObj.parametros['icone'] = false
        } else {
            newObj.parametros['icone'] = e.target.id
        }

        if (editing) {
            widgetEdit.widget = newObj
            this.setState({ blockScreen: false, showIcons: false, widgetEdit })
        } else {
            this.setState({ blockScreen: false, showIcons: false, novoWidget: newObj })
        }
    }

    saveNewWidget = () => {
        if (this.isTourDemoPersistenciaBloqueada()) return

        let userInfo = auth.getUserInfo()
        let widget = this.state.novoWidget
        let widgets = [...this.state.widgets]
        const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/reporte/supervisorio/'
        let equipamentosVinculados = []
    
        if (!widget.id_widget || !widget.descricao_widget) {
            helper.dispatchEvent("showAviso", { message: "Preencha todos os campos!" })
            return
        }
    
        this.setState({ blockScreen: true })
    
        widgets.push({
            id: uuidv4(),
            type: widget.id_widget,
            descricao: encodeURI(widget.descricao_widget),
            equipamento: widget.equipamento,
            mqtt: widget.equipamento_mqtt,
            campo: widget.campo,
            calcularVolume: widget.calcularVolume,
            parametros: widget.parametros
        })
    
        let supervisorio = this.state.supervisorioSelecionado
        supervisorio['widgets'] = JSON.stringify(widgets)
    
        if (widgets.length > 0) {
            for (let index = 0; index < widgets.length; index++) {
                if (!equipamentosVinculados.includes(widgets[index].equipamento) && widgets[index].equipamento !== false){
                    equipamentosVinculados.push(widgets[index].equipamento)
                }
                let referencias = widgets[index].parametros?.referencias ?? []
                if (referencias.length > 0) {
                    referencias.forEach((referencia) => {
                        if(!equipamentosVinculados.includes(referencia.parametro.equipamento.imei)) {
                            equipamentosVinculados.push(referencia.parametro.equipamento.imei)
                        }
                    })
                }
            }
        }
    
        if (equipamentosVinculados.length > 0) {
            let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }
            let data_send = new FormData()
    
            data_send.append("equipamentos", JSON.stringify(equipamentosVinculados))
            axios.post(requestURL, data_send, config_me).then((res) => {
                const novoWidget = { id_widget: false, descricao_widget: false, equipamento: false, campo: false, calcularVolume: false, parametros: false }
                this.handleModal("widget")
                this.setState({
                    blockScreen: false, 
                    equipamentosData: res.data, 
                    equipamentosVinculados, 
                    widgets, 
                    novoWidget,
                    needUpdate: true, 
                    supervisorioSelecionado: supervisorio,
                    layouts: parseSupervisorioLayouts(supervisorio.layout, widgets)
                })
                this.updateSupervisory(supervisorio)
            }).catch((error) => {
                console.error('Erro ao salvar widget:', error)
                this.setState({ blockScreen: false })
                helper.dispatchEvent("showAviso", { message: "Erro ao salvar widget!" })
            })
        } else {
            const novoWidget = { id_widget: false, descricao_widget: false, equipamento: false, campo: false, calcularVolume: false, parametros: false }
            this.handleModal("widget")
            this.setState({
                blockScreen: false,
                widgets,
                novoWidget,
                needUpdate: true,
                supervisorioSelecionado: supervisorio,
                layouts: parseSupervisorioLayouts(supervisorio.layout, widgets)
            })
            this.updateSupervisory(supervisorio)
        }
    }

    handleIntevalo = (e) => {
        let { apresentacao } = this.state
        apresentacao.intervalo = e
        this.setState({ apresentacao })
    }

    closeMenu = () => {
        document.querySelector('details.hdv-super-popup').open = false
    }

    convertDataTimeZone = (UTCDate) => {
        const timezone = auth.getUserInfo()?.timezone ?? this.props.timezone
        let timezoneDate = moment.tz(UTCDate, 'UTC')
        let formatted = timezoneDate.tz(timezone)
        return formatted
    }

    calcDifferenceInMinutes(timestamp) {
        const ultimoReporte = new Date(timestamp * 1000)
        const diffTime = (new Date().getTime() - ultimoReporte.getTime())
        let days = (diffTime / (1000 * 60 * 60 * 24)).toFixed(2)
        return days * 1440
    }

    convertTimezone = (dataUTC, format) => {
        if (dataUTC) {
            const systemTZ = Intl.DateTimeFormat().resolvedOptions().timeZone
            try {
                let timezone = auth.getUserInfo()?.timezone ?? this.props.timezone
                if (!timezone) {
                    timezone = systemTZ
                }

                return moment.tz(dataUTC, 'UTC').tz(timezone).format(format)
            } catch (err) {
                return moment.tz(new Date().getTime(), 'UTC').tz(systemTZ).format(format)
            }
        }
    }

    isEditable = () => {
        if (this.props.shared) return false

        const userCanEdit = (auth?.getUserInfo()?.['tipo'] === "cliente") ? false : true

        return this.state.editEnabled && userCanEdit
    }

    constrainReservatorioV2Resize = (layout, oldItem, newItem, placeholder, e, node) => {
        if (!isReservatorioV2LayoutItem(this.state.widgets, newItem?.i)) return

        const size = fitReservatorioV2Size(oldItem, newItem, getSupervisorioGridWidth(node))
        newItem.w = size.w
        newItem.h = size.h
        if (placeholder) {
            placeholder.w = size.w
            placeholder.h = size.h
        }
    }

    calcExpiration = () => {
        let { expira } = this.props.link

        let difference = new Date(expira).getTime() - new Date().getTime()
        let days = Math.ceil(difference / (1000 * 3600 * 24) - 1)

        return `Link expira em: ${days} ${days === 1 ? "dia" : "dias"}`
    }

    handleTab = (index) => {
        this.setState({ tab: index })
    }

    toggleModalReferencias = (status) => {
        if(!status) {
            this.setState({
                referencias: {
                    detalhes: { parametro: "", cor: "#000000" },
                    validacao: { parametro: true, cor: true }
                }
            })
        }

        this.setState({ modal_referencias: status })
    }

    handleChangeReferencia = (field, value) => {
        const { detalhes, validacao } = {...this.state.referencias}
        detalhes[field] = value
        validacao[field] = true
        this.setState({ referencias: { detalhes, validacao }})
    }

    addReferencia = () => {
        const { novoWidget, widgetEdit, referencias, key_edit_referencia, modal } = this.state
        let erro = false

        for(let i in referencias.detalhes) {
            if (!referencias.detalhes[i]) {
                referencias.validacao[i] = false
                erro = true
            } else {
                referencias.validacao[i] = true
            }
        }

        if(erro) {
            this.setState({ referencias })
            return
        }

        const array_referencias = modal.edit ? widgetEdit.widget?.parametros?.referencias : novoWidget.parametros.referencias

        if(key_edit_referencia !== null) {
            array_referencias[key_edit_referencia] = referencias.detalhes
        } else {
            array_referencias.push(referencias.detalhes)
        }

        this.setState({
            referencias: {
                detalhes: { parametro: "", cor: "#000000" },
                validacao: { parametro: true, cor: true }
            },
            key_edit_referencia: null,
            novoWidget,
            widgetEdit
        })
    }

    editReferencia = (key_edit) => {
        const { novoWidget, widgetEdit, referencias, modal } = this.state
        let array_referencias = modal.edit ? widgetEdit.widget?.parametros?.referencias : novoWidget.parametros.referencias

        array_referencias = array_referencias.filter((_,index) => index == key_edit) 

        if(array_referencias.length > 0) {
            referencias.detalhes = JSON.parse(JSON.stringify(array_referencias[0]))
        }

        this.setState({ key_edit_referencia: key_edit, referencias })
    }

    cancelEditReferencia = () => {
        this.setState({
            referencias: {
                detalhes: { parametro: "", cor: "#000000" },
                validacao: { parametro: true, cor: true }
            },
            key_edit_referencia: null
        })
    }

    deleteReferencia = (key_delete) => {
        let { novoWidget, widgetEdit, modal } = this.state
        let array_referencias = modal.edit ? widgetEdit.widget.parametros.referencias : novoWidget.parametros.referencias

        array_referencias = array_referencias.filter((_,index) => index != key_delete) 

        if(modal.edit) {
            widgetEdit.widget.parametros.referencias = array_referencias
            this.setState({ widgetEdit })
        } else {
            novoWidget.parametros.referencias = array_referencias
            this.setState({ novoWidget })
        }
    }

    renderRowsReferencias = () => {
        const { novoWidget, widgetEdit, modal, key_edit_referencia } = this.state
        const referencias = modal.edit ? widgetEdit.widget?.parametros?.referencias ?? [] : novoWidget?.parametros?.referencias ?? []

        return referencias.map((referencia, key) => (
            <tr key={key}>
                <td>{referencia.parametro.label}</td>
                <td>
                    <div style={{ background: referencia.cor, width: "50px", height: "30px", borderRadius: "5px" }}></div>
                </td>
                <td className='clean-action'>
                    {
                        key_edit_referencia === null && (
                            <>
                                <button style={{ padding: "0px 5px", height: "30px" }} onClick={() => this.editReferencia(key)} className="hdv-btn-forms hdv-btn-yellow">Editar</button>
                                <button style={{ padding: "0px 5px", height: "30px" }} onClick={() => this.deleteReferencia(key)} className="hdv-btn-forms hdv-btn-red">Excluir</button>
                            </>
                        )
                    }
                </td>
            </tr>
        ))
    }

    render() {
        let { supervisorioSelecionado, novoWidget, widgetEdit, tab, isComponenteIsolado, referencias, key_edit_referencia, modal } = this.state
        const isCliente = auth.getUserInfo()?.tipo === "cliente" ? true : false
        if (this.state.redirect.to)
            return <Redirect to={this.state.redirect.to} strict={false} />

        const array_referencias = modal.edit ? widgetEdit.widget?.parametros?.referencias ?? [] : novoWidget?.parametros?.referencias ?? []

        return (
            <div data-tour="supervisorio-root" style={{ opacity: this.state.opacity, backgroundColor: "#d2d2d2" }}>
                <Modal isOpen={this.state.modal.apresentacao} toggle={() => this.handleModal("apresentacao")} className={this.props.className}>
                    <ModalHeader toggle={() => this.handleModal("apresentacao")}>Modo Apresentação</ModalHeader>
                    <ModalBody>
                        <div style={{ padding: '10px 0' }}>
                            <label className="required">Selecione o intervalo</label>
                            <Select
                                value={this.state.apresentacao.intervalo}
                                onChange={(e) => this.handleIntevalo(e)}
                                options={[
                                    { label: '30 Segundos', value: 30_000 },
                                    { label: '1 Minuto', value: 60_000 },
                                    { label: '2 Minutos', value: 120_000 },
                                    { label: '3 Minutos', value: 180_000 },
                                    { label: '5 Minutos', value: 300_000 },
                                    { label: '10 Minutos', value: 600_000 },
                                    { label: '15 Minutos', value: 900_000 },
                                ]}
                            />
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        {this.state.apresentacao.function === null
                            ? <Button color="success" onClick={this.toggleApresentacao}>Iniciar</Button>
                            : <Button color="danger" onClick={this.toggleApresentacao}>Parar</Button>
                        }
                        {' '}
                        <Button color="default" onClick={() => this.handleModal("apresentacao")}>Fechar</Button>
                    </ModalFooter>
                </Modal>

                <Modal size="md" isOpen={this.state.modal.supervisorio} toggle={() => this.handleModal("supervisorio")} className={this.props.className} data-tour="supervisorio-modal-criar">
                    <ModalHeader toggle={() => this.handleModal("supervisorio")}>Criar novo supervisório</ModalHeader>
                    <ModalBody>
                        <div>
                            <div className="row">
                                <div className="col-md-6" data-tour="supervisorio-criar-descricao">
                                    <label className="hdv-barsuper-label" htmlFor="descricao">Descrição</label>
                                    <input onChange={this.newSupervisory} className="hdv-barsuper-input" type="text" id="descricao" name="descricao" />
                                </div>
                                <div style={{ display: isCliente ? "none" : "block" }} className="col-md-6" data-tour="supervisorio-criar-tipo">
                                    <label className="hdv-barsuper-label" htmlFor="tipo">Tipo</label>
                                    <div className="d-flex">
                                        <label className="hdv-sup-label">
                                            <input onChange={this.newSupervisory} type="radio" id="tipo" name="tipo" value="cliente" checked={this.state.novoSupervisorio['tipo'] === "cliente"} />
                                            Cliente
                                        </label>

                                        <label className="hdv-sup-label">
                                            <input onChange={this.newSupervisory} type="radio" id="tipo" name="tipo" value="empresa" checked={this.state.novoSupervisorio['tipo'] === "empresa"} />
                                            Empresa
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <label
                                style={{ display: (this.state.novoSupervisorio['tipo'] === "cliente") ? "block" : "none" }}
                                className="hdv-barsuper-label hdv-barsuper-label-margin" htmlFor="cliente_id">
                                Selecione o Cliente
                            </label>
                            <select
                                data-tour="supervisorio-criar-cliente"
                                style={{ minWidth: '100%', display: (this.state.novoSupervisorio['tipo'] === "cliente") ? "block" : "none" }}
                                onChange={this.newSupervisory} id="cliente_id" name="cliente_id" className="hdv-barsuper-select">
                                <option value="">-- Selecione o Cliente --</option>
                                {this.state.clientes.map((cliente, key) => {
                                    return <option key={key} value={cliente.id}>{cliente.nome_fantasia}</option>
                                })}
                            </select>
                        </div>
                    </ModalBody>
                    <ModalFooter data-tour="supervisorio-criar-acoes">
                        <Button color="success" onClick={() => { this.saveSupervisory(); this.handleModal("supervisorio") }}>Criar</Button>{' '}
                        <Button color="default" onClick={() => this.handleModal("supervisorio")}>Fechar</Button>
                    </ModalFooter>
                </Modal>

                <Modal size="lg" isOpen={this.state.modal.widget} toggle={() => this.handleModal("widget")} className={this.props.className} data-tour="supervisorio-modal-widget">
                    <ModalHeader toggle={() => this.handleModal("widget")}>Novo Componente</ModalHeader>
                    <ModalBody>
                        <div>
                            <label className="hdv-barsuper-label" htmlFor="descricao_widget">Descrição</label>
                            <input data-tour="supervisorio-widget-descricao" onChange={this.newWidget} className="hdv-barsuper-input" type="text" id="descricao_widget" name="descricao_widget" />

                            <div className="row">
                                <div className="col-md-6" style={{ display: isComponenteIsolado ? "none" : "block" }} data-tour="supervisorio-widget-monitorado">
                                    <label className="hdv-barsuper-label hdv-barsuper-label-margin" htmlFor="monitorado">
                                        Selecione o Monitorado
                                    </label>
                                    <select
                                        onChange={this.getMonitoradoFields}
                                        id="monitorado" name="monitorado" className="hdv-barsuper-select">
                                        <option value="">-- Monitorados --</option>
                                        {
                                            this.state.monitorados.map((monitorado, key) => {
                                                return <option key={key} value={monitorado.id}>{monitorado.nome}</option>
                                            })
                                        }
                                    </select>
                                </div>
                                <div className="col-md-6" style={{ display: isComponenteIsolado ? "none" : "block" }} data-tour="supervisorio-widget-parametro">
                                    <label className="hdv-barsuper-label hdv-barsuper-label-margin" htmlFor="campo">Selecione o Parâmetro</label>
                                    <select onChange={this.newWidget} id="campo" name="campo" className="hdv-barsuper-select">
                                        <option value="">-- Campos Disponíveis --</option>
                                        {
                                            this.state.camposDisponiveis.map((campo, key) => {
                                                return <option key={key} value={campo.value}>{campo.label}</option>
                                            })
                                        }
                                    </select>
                                </div>
                            </div>

                            <label className="hdv-barsuper-label hdv-barsuper-label-margin" htmlFor="id_widget">
                                Selecione o tipo do componente
                            </label>
                            <select data-tour="supervisorio-widget-tipo" onChange={this.showWidgetParams} id="id_widget" name="id_widget" className="hdv-barsuper-select">
                                <option value="">-- Componentes --</option>
                                {
                                    this.state.widgetsDisponiveis.filter(w => !w?.disabled).map((widget, key) => {
                                        return <option key={key} value={widget.id}>{widget.descricao}</option>
                                    })
                                }
                            </select>
                            {(this.state.htmlCampos?.length > 0)
                                ?
                                <fieldset
                                    data-tour="supervisorio-widget-config"
                                    style={{ display: (this.state.novoWidget['id_widget'] !== false) ? "block" : "none", marginTop: "15px" }}
                                    className="hdv-widget-config-fieldset">
                                    <legend className="hdv-widget-config-fieldset-legend">Configurações do Componente:</legend>
                                    {this.state.htmlCampos}
                                </fieldset>
                                :
                                null
                            }
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button data-tour="supervisorio-widget-adicionar" color="success" onClick={() => { this.saveNewWidget() }}>Adicionar</Button>{' '}
                        <Button color="default" onClick={() => this.handleModal("widget")}>Fechar</Button>
                    </ModalFooter>
                </Modal>

                <Modal
                    isOpen={this.state.modal.edit}
                    toggle={() => this.handleModal("edit")}
                    className={`${this.props.className} modal-lg`}
                    data-tour="supervisorio-modal-edit">
                    <ModalHeader toggle={() => this.handleModal("edit")}>Editar Componente</ModalHeader>
                    <ModalBody>
                        <div className="hdv-widget-popup">
                            <label className="mb-3" data-tour="supervisorio-edit-descricao">Descrição
                                <br />
                                <input
                                    type="text"
                                    className="hdv-barsuper-input"
                                    value={this.state.widgetEdit.input}
                                    onChange={(e) => this.setState({ widgetEdit: { ...this.state.widgetEdit, input: e.target.value } })}
                                />
                            </label>
                            {this.showEditParams()}
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button data-tour="supervisorio-edit-excluir" color="danger" onClick={() => this.deleteWidget(this.state.widgetEdit.widget.id)}>
                            Excluir Componente
                        </Button>{' '}
                        <Button color="primary" onClick={this.saveWidget}>Salvar</Button>{' '}
                        <Button color="default" onClick={() => this.handleModal("edit")}>Fechar</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.modal.delete} toggle={() => this.handleModal("delete")} className={this.props.className}>
                    <ModalHeader toggle={() => this.handleModal("delete")}>Deletar Supervisório</ModalHeader>
                    <ModalBody>
                        <div style={{ padding: '20px 0', fontSize: '16px', opacity: '0.9' }}>
                            Realmente deseja deletar o Supervisório?
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="danger" onClick={() => { this.deleteSupervisory(); this.handleModal("delete") }}>Deletar</Button>{' '}
                        <Button color="default" onClick={() => this.handleModal("delete")}>Fechar</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.modal.erro} toggle={() => this.handleModal("erro")}>
                    <ModalHeader toggle={() => this.handleModal("erro")}>Erro</ModalHeader>
                    <ModalBody>
                        <div style={{ padding: '20px 0', fontSize: '16px', opacity: '0.9' }}>
                            Erro ao carregar supervisório.
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="default" onClick={() => this.handleModal("erro")}>Fechar</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.modal_referencias} toggle={() => this.toggleModalReferencias(false)} className="modal-lg">
                    <ModalHeader toggle={() => this.toggleModalReferencias(false)}>Referências</ModalHeader>
                    <ModalBody>
                        <div className="hdv-form-default">
                            <div className="row">
                                <div className="col-md-6">
                                    <label className="required">Parâmetro</label>
                                    <Select 
                                        value={referencias.detalhes.parametro} 
                                        onChange={(e) => this.handleChangeReferencia("parametro", e)}
                                        options={
                                            this.state.camposDisponiveis
                                            .map((parametro) => ({label: parametro.label, value: parametro.value, id: parametro.id, equipamento: parametro.equipamento}))
                                            .filter((parametro) => !array_referencias.some((referencia) => referencia.parametro.value == parametro.value))
                                        }
                                    />
                                    {!referencias.validacao.parametro ? <span id="validacao-parametro">Campo não pode ser nulo!</span> : null}
                                </div>
                                <div style={{ display: "flex", flexDirection: "column" }} className="col-md-2">
                                    <label className="required">Cor</label>
                                    <input value={referencias.detalhes.cor} id="cor" onChange={(e) => this.handleChangeReferencia("cor", e.target.value)} style={{ width: "80px", height: "40px", border: "none" }} type="color" />
                                </div>

                                {
                                    key_edit_referencia !== null ? 
                                        <div className="col-md-4 d-flex align-items-end">
                                            <button className='hdv-btn-forms hdv-btn-green w-100' onClick={this.addReferencia}>{key_edit_referencia !== null ? "Atualizar" : "Adicionar"}</button>
                                            <button className='hdv-btn-forms hdv-btn-yellow w-100 m-0' onClick={this.cancelEditReferencia}>Cancelar</button>
                                        </div>
                                    :
                                        <div className="col-md-4 d-flex align-items-end">
                                            <button className='hdv-btn-forms hdv-btn-green w-100' onClick={this.addReferencia}>{key_edit_referencia !== null ? "Atualizar" : "Adicionar"}</button>
                                        </div>
                                }
                               
                            </div>

                            <table className="table afira-table">
                                <thead>
                                    <tr>
                                        <th>Parâmetro</th>
                                        <th>Cor</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.renderRowsReferencias()}
                                </tbody>
                            </table>
                        </div>
                    </ModalBody>
                </Modal>

                <div className="row hdv-barsuper">
                    {this.props.shared
                        ?
                        <div className="d-flex justify-content-between align-items-center" style={{ width: '100%' }}>
                            <h6 className="hdv-sup-title pt-1 m-0">{this.state.supervisorioSelecionado.descricao}</h6>
                            <span style={{ textAlign: "left", display: "flex", alignItems: "center" }}>
                                {this.state.updating ? <i className="fa fa-sync fa-2x spinning mr-2"></i> : null}
                                {this.calcExpiration()}
                            </span>
                        </div>
                        :
                        <Tabs data-tour="supervisorio-abas" style={{ display: "flex", alignItems: "end", margin: "0px" }} className="tabs-style" selectedIndex={this.state.tab} onSelect={(i) => this.handleTab(i)}>
                            <TabList style={{ borderBottom: "none", margin: "3px 0 10px", padding: "0" }}>
                                <Link
                                    to='/'
                                    style={{
                                        color: "var(--fonte_titulo_abas)",
                                        padding: "20px 20px 20px 0",
                                        paddingLeft: "15px",
                                        transition: "opacity 0.2s",
                                        fontSize: "26px",
                                        opacity: "1"
                                    }}
                                    onMouseEnter={(e) => e.target.style.opacity = "0.7"}
                                    onMouseLeave={(e) => e.target.style.opacity = "1"}>
                                    <img src={arrowLeft} style={{ width: "24px" }} />
                                </Link>
                                <Tab
                                    data-tour="supervisorio-tab-widgets"
                                    style={{
                                        transition: "opacity 0.2s",
                                        opacity: "1"
                                    }}
                                    onMouseEnter={(e) => e.target.style.opacity = "0.7"}
                                    onMouseLeave={(e) => e.target.style.opacity = "1"}>
                                    Widgets
                                </Tab>
                                <Tab
                                    data-tour="supervisorio-tab-planta"
                                    style={{
                                        transition: "opacity 0.2s",
                                        opacity: "1"
                                    }}
                                    onMouseEnter={(e) => e.target.style.opacity = "0.7"}
                                    onMouseLeave={(e) => e.target.style.opacity = "1"}>
                                    Planta Baixa
                                </Tab>
                            </TabList>
                        </Tabs>
                    }

                    {!this.props.shared
                        ?
                        <>
                            <div className="col-md-6 d-flex align-items-center justify-content-center">
                                {auth?.getUserInfo()?.['tipo'] !== "cliente" && tab !== 1 ?
                                    <button data-tour="supervisorio-novo" className="hdv-barsuper-button d-flex align-items-center hdv-barsuper-new" onClick={() => this.handleModal("supervisorio")}>
                                        <i className="fa fa-plus fa-2x"></i>
                                        Novo
                                    </button>
                                    : ""
                                }

                                <div className="select-supervisory" data-tour="supervisorio-seletor">
                                    {this.state.editEnabled
                                        ?
                                        <div className="d-flex align-items-center" style={{ position: 'relative' }}>
                                            <input type="text" value={this.state.supervisorioSelecionado?.descricao} onChange={(e) => this.setState({ supervisorioSelecionado: { ...this.state.supervisorioSelecionado, descricao: e.target.value }, needUpdate: true })} />
                                            <i className="fa fa-pen fa-2x" style={{
                                                position: 'absolute',
                                                right: '10px',
                                                top: '22px',
                                                transform: 'translateY(-50%)',
                                                pointerEvents: 'none'
                                            }}></i>
                                        </div>
                                        :
                                        <Select
                                            value={supervisorioSelecionado ? { label: supervisorioSelecionado?.descricao, value: supervisorioSelecionado?.id } : null}
                                            onChange={(e) => this.selectSupervisory(e.supervisorio.id)}
                                            options={this.sortSupervisories()}
                                            noOptionsMessage={() => "Nenhum supervisório encontrado"}
                                            placeholder={"Selecione um supervisório..."}
                                            menuIsOpen={typeof this.state.tourSeletorMenuAberto === 'boolean' ? this.state.tourSeletorMenuAberto : undefined}
                                        />
                                    }
                                </div>

                                {auth?.getUserInfo()?.['tipo'] !== "cliente" && tab !== 1 ?
                                    <button
                                        data-tour="supervisorio-salvar"
                                        className="hdv-barsuper-button hdv-barsuper-update d-flex align-items-center"
                                        disabled={!(this.state.needUpdate) || this.isTourDemoPersistenciaBloqueada()}
                                        onClick={this.actionUpdateSupervisory}>
                                        {this.state.updating ?
                                            <>
                                                <i className="fa fa-sync fa-2x spinning"></i>
                                                Atualizando
                                            </>
                                            :
                                            <>
                                                <i className="fa fa-cloud-upload-alt fa-2x"></i>
                                                Salvar
                                            </>
                                        }
                                    </button>
                                    : ""
                                }

                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {
                                    !this.props.shared && auth.isMasterOrAdmin() ? (
                                        <span
                                            data-tour="help-supervisorio"
                                            title="Ajuda"
                                            onClick={() => tourManager.start('supervisorio')}
                                            style={{ marginRight: '10px', marginTop: '7px', display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                            <i className="las la-question-circle hdv-help-tour-icon"></i>
                                        </span>
                                    ) : null
                                }
                                {
                                    auth?.getUserInfo()?.['tipo'] === "cliente" ?
                                        <details
                                            className="hdv-super-popup"
                                            onClick={(e) => { if (e.target.classList.contains("hdv-super-popup")) e.target.open = false }}
                                        >
                                            <summary data-tour="supervisorio-opcoes" className="hdv-barsuper-button d-flex align-items-center" style={{ backgroundColor: "#D2D2D2" }} >
                                                <i className="fa fa-bars fa-2x" style={{ userSelect: 'none', color: "#222" }} />
                                                <span style={{ color: "black", marginLeft: "6px" }}>Opções</span>
                                            </summary>
                                            <section
                                                className="px-3 popup"
                                                style={{
                                                    boxShadow: "rgb(236, 236, 236) 5px 5px 0px 3px",
                                                    border: "3px solid rgb(236,236,236)",
                                                    borderRadius: "15px"
                                                }}
                                            >
                                                <div className="row pt-2">
                                                    <div className="col-md-12">
                                                        <button
                                                            className="hdv-popup-button hdv-barsuper-slide"
                                                            onClick={() => {
                                                                this.closeMenu()
                                                                this.handleModal("apresentacao")
                                                            }}>
                                                            <i className="fa fa-play fa-2x"></i>
                                                            Apresentação
                                                        </button>
                                                    </div>
                                                </div>
                                            </section>
                                        </details>
                                            : tab !== 1 ?
                                            <details
                                                data-tour="supervisorio-opcoes-menu"
                                                className="hdv-super-popup"
                                                onClick={(e) => { if (e.target.classList.contains("hdv-super-popup")) e.target.open = false }}>
                                                <summary data-tour="supervisorio-opcoes" className="hdv-barsuper-button d-flex align-items-center" style={{ backgroundColor: "#D2D2D2" }} >
                                                    <i className="fa fa-bars fa-2x" style={{ userSelect: 'none', color: "#222" }} />
                                                    <span style={{ color: "black", marginLeft: "6px" }}>Opções</span>
                                                </summary>
                                                <section
                                                    className="px-3 popup"
                                                    style={{
                                                        boxShadow: "rgb(236, 236, 236) 5px 5px 0px 3px",
                                                        border: "3px solid rgb(236,236,236)",
                                                        borderRadius: "15px"
                                                    }}>
                                                    <div className="row pt-2">
                                                        <div className="col-md-6" style={{ paddingRight: '4px' }}>
                                                            <button
                                                                data-tour="supervisorio-novo-componente"
                                                                disabled={(this.state.supervisorioSelecionado) ? false : true}
                                                                className="hdv-popup-button hdv-barsuper-new m-0"
                                                                onClick={() => {
                                                                    this.closeMenu()
                                                                    this.handleModal("widget")
                                                                    this.getMonitorados()
                                                                }}>
                                                                <i className="fa fa-plus fa-2x"></i>
                                                                Novo Componente
                                                            </button>
                                                        </div>
                                                        <div className="col-md-6" style={{ paddingLeft: '4px' }}>
                                                            <button
                                                                data-tour="supervisorio-apresentacao"
                                                                style={{ display: (auth?.getUserInfo()?.['tipo'] === "cliente") ? "none" : "inline" }}
                                                                className="hdv-popup-button hdv-barsuper-slide"
                                                                onClick={() => {
                                                                    this.closeMenu()
                                                                    this.handleModal("apresentacao")
                                                                }}>
                                                                <i className="fa fa-play fa-2x"></i>
                                                                Apresentação
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <hr style={{ width: '100%', border: '1px solid #ddd', display: (auth?.getUserInfo()?.['tipo'] === "cliente") ? "none" : "inline" }} />
                                                    <label style={{ opacity: "0.8" }}>Outros</label>
                                                    <SupervisorioLinkForm supervisorioSelecionado={this.state.supervisorioSelecionado} />

                                                    <button
                                                        data-tour="supervisorio-editar"
                                                        style={{ display: (auth?.getUserInfo()?.['tipo'] === "cliente") ? "none" : "inline" }}
                                                        disabled={!Boolean(this.state.supervisorioSelecionado)}
                                                        onClick={this.toggleEdit}
                                                        className="hdv-barsuper-default hdv-popup-button">
                                                        <i className="fa fa-pen fa-2x"></i>
                                                        {this.state.editEnabled ? "Desativar edição" : "Editar"}
                                                    </button>
                                                    <button style={{ display: (auth?.getUserInfo()?.['tipo'] === "cliente") ? "none" : "inline" }}
                                                        disabled={(this.state.supervisorioSelecionado) ? false : true}
                                                        onClick={() => this.handleModal("delete")}
                                                        className="hdv-barsuper-delete hdv-popup-button mt-1">
                                                        <i className="fa fa-trash fa-2x"></i>
                                                        Deletar Supervisório
                                                    </button>
                                                </section>
                                            </details>
                                            : <div className="hdv-btn-group" style={{ minWidth: "250px" }}></div>
                                }
                            </div>
                        </>
                        :
                        null
                    }
                </div>
                <div
                    className="hdv-bodysuper"
                    data-tour="supervisorio-canvas"
                    data-preenchido={hasRealWidgets(this.state.widgets) ? "true" : "false"}
                    data-tour-demo={this.state.tourDemoInjected || hasSupervisorioTourDemoWidgets(this.state.widgets) ? "true" : "false"}>
                    <Tabs forceRenderTabPanel className="tabs-style" selectedIndex={this.state.tab} onSelect={(i) => this.handleTab(i)}>
                        <TabPanel>
                            <ResponsiveReactGridLayout
                                className={this.state.editEnabled ? "layout-grid" : "layout"}
                                cols={{ lg: 12, md: 12, sm: 12, xs: 12, xxs: 12 }}
                                rowHeight={30}
                                preventCollision={false}
                                draggableHandle='.widget-drag-handle'
                                isDraggable={this.isEditable()}
                                isResizable={this.isEditable()}
                                layouts={(this.state.layouts) ? applyReservatorioV2LayoutMins(this.state.layouts, this.state.widgets, !this.state.editEnabled) : {}}
                                onResize={this.constrainReservatorioV2Resize}
                                onLayoutChange={(layout, layouts) => {
                                    try {
                                        document.querySelectorAll('*[id^="chart-"]').forEach((chart) => {
                                            const parent = chart.parentElement
                                            const child = chart.querySelector("div")
                                            child.style.height = `${parent?.clientHeight - 80}px`
                                        })
                                    } catch (err) {
                                        console.error(err)
                                    }

                                    let supervisorio = this.state.supervisorioSelecionado

                                    if (this.props.shared) return

                                    if (supervisorio) {
                                        const layoutCurrent = supervisorio['layout']

                                        if (layoutCurrent !== JSON.stringify(layouts)) {
                                            try {
                                                if (JSON.parse(layoutCurrent || '{}')?.lg?.length < layouts?.lg?.length && layout?.length) {
                                                    let array_y = layout.map((item) => item.y)
                                                    let maior_y = array_y.reduce((acumulador, valorAtual) => valorAtual > acumulador ? valorAtual : acumulador)
                                                
                                                    layout[layout.length - 1].y = maior_y + 1
                                                    layouts.lg = layout
                                                }
                                            } catch (err) {}

                                            supervisorio['layout'] = JSON.stringify(layouts)

                                            this.setState({ supervisorioSelecionado: supervisorio, layouts: layouts })
                                            if (!this.isTourDemoPersistenciaBloqueada()) {
                                                this.updateSupervisory(supervisorio)
                                            }
                                        }
                                    }
                                }}>

                                {this.state?.widgets?.map((widget, key) => {
                                    const isHighlightedWidget = widget.id === TOUR_DEMO_WIDGET_ID
                                    let { equipamentosData } = this.state
                                    let value = 0
                                    let metric = ""
                                    let type_el = false
                                    let atrasado = false
                                    let date = ""
                                    let unidade = ""
                                    let evento = null
                                    let widgetDescricao = widget.descricao

                                    try {
                                        widgetDescricao = decodeURI(widgetDescricao)
                                    } catch {
                                        widgetDescricao = widget.descricao
                                    }

                                    try {
                                        value = equipamentosData?.[widget.equipamento]?.[widget.campo]
                                        unidade = equipamentosData?.[widget.equipamento]?.unidades?.[widget.campo]
                                        evento = (typeof (equipamentosData[widget.equipamento]) !== "undefined") ? equipamentosData?.[widget.equipamento] : false
                                        date = this.convertTimezone(evento?.['timestamp_dispositivo'] * 1000, 'DD/MM HH:mm')
                                    } catch (err) {
                                        console.error(err)
                                    }

                                    if (evento && "minutos_alerta_semcomunicacao" in widget.parametros) {
                                        const asMinutes = this.calcDifferenceInMinutes(evento?.timestamp_dispositivo)
                                        const hasAlert = widget.parametros.minutos_alerta_semcomunicacao != false && widget.parametros.minutos_alerta_semcomunicacao > 0

                                        if (hasAlert && asMinutes > parseFloat(widget.parametros.minutos_alerta_semcomunicacao)) {
                                            atrasado = true
                                        } else if (asMinutes > 2160) {
                                            atrasado = true
                                        }
                                    }

                                    const common = {
                                        ...widget,
                                        shared: this.props.shared,
                                        id: helper.randomKey(7),
                                        originalId: widget.id,
                                        params: widget.parametros,
                                        unidade: unidade,
                                        timestamp: (evento['timestamp_dispositivo'] * 1000),
                                        ultimoEvento: (settings = {}) => {
                                            let ultimaComunicacao = null
                                            let showUnity = true

                                            try {
                                                if (evento && 'timestamp_dispositivo' in evento) {
                                                    ultimaComunicacao = this.convertTimezone(evento['timestamp_dispositivo'] * 1000, 'DD/MM/YYYY HH:mm')
                                                }
                                            } catch (err) {
                                                console.error(err)
                                            }

                                            if (settings?.showUnity == false) {
                                                showUnity = false
                                            }

                                            return (
                                                <>
                                                <div className="hdv-top-bar-bloco">
                                                    {this.state.editEnabled ?
                                                        <i data-tour={isHighlightedWidget ? "supervisorio-widget-menu" : undefined} className={this.props.shared ? "hdv-noshow-item" : "hdv-widget-options fa fa-ellipsis-v"}
                                                            onClick={(e) => {
                                                                this.setState({
                                                                    widgetEdit: {
                                                                        widget,
                                                                        element: e.currentTarget.parentElement.querySelector(".hdv-top-bar-bloco span"),
                                                                        input: widgetDescricao
                                                                    }
                                                                })
                                                                this.handleModal("edit")
                                                            }}
                                                        />
                                                        :
                                                        null
                                                    }
                                                    <i data-status={atrasado ? "Atrasado" : "Atualizado"} className="fa fa-square-full"></i>
                                                    <span>{widgetDescricao}</span>
                                                    <div className="hdv-top-bar-hidden">
                                                        <p><b>Equipamento:</b> {evento?.id_dispositivo ?? "---"}</p>
                                                        <p><b>Status:</b> {(!atrasado) ? <span>Atualizado</span> : <span>Com atraso</span>}</p>
                                                        <p><b>Última atualização:</b> {ultimaComunicacao ?? "---"}</p>
                                                    </div>
                                                </div>
                                                
                                                {this.state.editEnabled && <div data-tour={isHighlightedWidget ? "supervisorio-widget-mover" : undefined} className="widget-drag-handle"><i class="las la-arrows-alt"></i></div>} 
                                                </>
                                            )
                                        }
                                    }

                                    switch (widget.type) {
                                        case "1":
                                            return (
                                                <div className="div-sample" data-tour={isHighlightedWidget ? "supervisorio-widget" : undefined} key={widget.id} data-grid={{ w: 6, h: 12, x: 0, y: 6, minW: 2, minH: 6, maxH: 14 }}>
                                                    <Reservatorio dataWidget={{ ...common, value, static: true }} key={key} />
                                                </div>
                                            )
                                        case "2":
                                            return (
                                                <div className="div-sample" data-tour={isHighlightedWidget ? "supervisorio-widget" : undefined} key={widget.id} data-grid={{ w: 3, h: 4, x: 0, y: 6, minW: 3, minH: 4 }}>
                                                    <ValorAtual dataWidget={{ ...common, value, unidade, metric, type_el }} key={key} />
                                                </div>
                                            )
                                        case "3":
                                            return (
                                                <div className="div-sample" data-tour={isHighlightedWidget ? "supervisorio-widget" : undefined} key={widget.id} data-grid={{ w: 2, h: 4, x: 0, y: 6, minW: 2, minH: 4 }}>
                                                    <Imagem key={key} />
                                                </div>
                                            )
                                        case "4":
                                            return (
                                                <div className="div-sample" data-tour={isHighlightedWidget ? "supervisorio-widget" : undefined} key={widget.id} data-grid={{ w: 6, h: 5, x: 0, y: 6, minW: 4, minH: 5 }}>
                                                    <MaximoAtual dataWidget={{ ...common, value }} key={key} />
                                                </div>
                                            )
                                        case "5":
                                            return (
                                                <div className="div-sample" data-tour={isHighlightedWidget ? "supervisorio-widget" : undefined} key={widget.id} data-grid={{ w: 2, h: 12, x: 0, y: 6, minW: 2, minH: 12 }}>
                                                    <Poco dataWidget={{ ...common, id: key, forceupdate: 0, value, event: evento }} key={key} />
                                                </div>
                                            )
                                        case "6":
                                            return (
                                                <div className="div-sample" data-tour={isHighlightedWidget ? "supervisorio-widget" : undefined} key={widget.id} data-grid={{ w: 6, h: 12, x: 18, y: 6, minW: 4, minH: 6 }}>
                                                    <GraficoLinha dataWidget={{ ...common, value: value, date }} equipamentosData={equipamentosData} key={key} />
                                                </div>
                                            )
                                        case "7":
                                            return (
                                                <div className="div-sample" data-tour={isHighlightedWidget ? "supervisorio-widget" : undefined} key={widget.id} data-grid={{ w: 6, h: 12, x: 0, y: 6, minW: 4, minH: 6 }}>
                                                    <GraficoBarra dataWidget={{ ...common, value: value, date }} key={key} />
                                                </div>
                                            )
                                        case "8":
                                            return (
                                                <div className="div-sample" data-tour={isHighlightedWidget ? "supervisorio-widget" : undefined} key={widget.id} data-grid={{ w: 3, h: 4, x: 0, y: 6, minW: 3, minH: 4 }}>
                                                    <Status dataWidget={{ ...common, value }} key={key} />
                                                </div>
                                            )
                                        case "9":
                                            return (
                                                <div className="div-sample" data-tour={isHighlightedWidget ? "supervisorio-widget" : undefined} key={widget.id} data-grid={{ w: 3, h: 4, x: 0, y: 6, minW: 3, minH: 4 }}>
                                                    <VolumeDia dataWidget={{ ...common, value, metric, type_el }} key={key} />
                                                </div>)
                                        case "10":
                                            return (
                                                <div className="div-sample" data-tour={isHighlightedWidget ? "supervisorio-widget" : undefined} key={widget.id} data-grid={{ w: 3, h: 4, x: 0, y: 6, minW: 3, minH: 4 }}>
                                                    <ValorAtualV2 dataWidget={{ ...common, value, unidade, metric, type_el, }} key={key} />
                                                    {this.state.editEnabled && <div data-tour={isHighlightedWidget ? "supervisorio-widget-mover" : undefined} className="widget-drag-handle"><i class="las la-arrows-alt"></i></div>}
                                                </div>
                                            )
                                        case "11":
                                            return (
                                                <div className="div-sample" data-tour={isHighlightedWidget ? "supervisorio-widget" : undefined} key={widget.id} data-grid={{ w: 3, h: 8, x: 0, y: 6, minW: 3, minH: 8 }}>
                                                    <Comando dataWidget={{ ...common, value }} key={key} comandos={this.state.comandos} />
                                                    {this.state.editEnabled && <div data-tour={isHighlightedWidget ? "supervisorio-widget-mover" : undefined} className="widget-drag-handle"><i class="las la-arrows-alt"></i></div>}
                                                </div>
                                            )
                                        case "12":
                                            return (
                                                <div className="div-sample" data-tour={isHighlightedWidget ? "supervisorio-widget" : undefined} key={widget.id} data-grid={{ w: RESERVATORIO_V2_GRID.w, h: RESERVATORIO_V2_GRID.h, x: 0, y: 6, minW: RESERVATORIO_V2_GRID.minW, minH: RESERVATORIO_V2_GRID.minH, maxW: RESERVATORIO_V2_GRID.maxW, maxH: RESERVATORIO_V2_GRID.maxH }}>
                                                    <ReservatorioV2 dataWidget={{ ...common, value }} key={key} comandos={this.state.comandos} />
                                                </div>
                                            )
                                        case "13":
                                            return (
                                                <div className="div-sample" data-tour={isHighlightedWidget ? "supervisorio-widget" : undefined} key={widget.id} data-grid={{ w: 6, h: 8, x: 0, y: 6, minW: 4, minH: 6 }}>
                                                    <ListaAlertas 
                                                        dataWidget={{ ...common }} 
                                                        key={key} 
                                                        shared={this.props.shared} 
                                                        hash={this.props.hash}
                                                        editEnabled={this.state.editEnabled}
                                                        onEditWidget={(widgetEdit) => {
                                                            this.setState({ widgetEdit })
                                                            this.handleModal("edit")
                                                        }}
                                                    />
                                                </div>
                                            )
                                        case "14":
                                            return (
                                                <div className="div-sample" data-tour={isHighlightedWidget ? "supervisorio-widget" : undefined} key={widget.id} data-grid={{ w: 3, h: 8, x: 0, y: 6, minW: 3, minH: 8 }}>
                                                    <GraficoGauge dataWidget={{ ...common, value, unidade }} key={key} />
                                                    {this.state.editEnabled && <div data-tour={isHighlightedWidget ? "supervisorio-widget-mover" : undefined} className="widget-drag-handle"><i class="las la-arrows-alt"></i></div>}
                                                </div>
                                            )
                                    }
                                })
                                }
                            </ResponsiveReactGridLayout>
                        </TabPanel>
                        <TabPanel>
                            <PlantaBaixa
                                supervisorioSelecionado={supervisorioSelecionado}
                                idSupervisorio={supervisorioSelecionado?.id}
                                shared={this.props?.shared}
                                dataShared={this.props?.dadosPlantaBaixa}
                                hash={this.props.hash}
                            />
                        </TabPanel>
                    </Tabs>
                </div>
                <div className="hdv-overlay" style={{ "visibility": (this.state.blockScreen) ? "visible" : "hidden" }}></div>

                <div className="hdv-icons-list" style={{ "display": (this.state.showIcons) ? "block" : "none" }}>
                    <div><h2>Selecione um Ícone</h2></div>
                    <ul>
                        {helper.getIconList()?.map((icon, index) => (
                            <li key={index}>
                                <i onClick={this.saveSubParamIcon} className={`fa fa-${icon}`} id={`fa-${icon}`}></i>
                            </li>
                        ))
                        }
                    </ul>
                </div>
            </div >
        )
    }
}

function SupervisorioLink(props) {
    const [link, setLink] = useState({
        hash: null,
        supervisorio: null,
        timezone: null,
        expira: null
    })

    const [dadosPlantaBaixa, setDadosPlantaBaixa] = useState({})

    function checkHash() {
        const hash = props.match.params.hash
        const url = `${cfg.base_api_url + cfg.api_v2}/check-supervisorio-link/${hash}/`

        if (hash) {
            axios({
                url: url,
                method: "GET",
                headers: { 'Authorization': 'Bearer ' + auth.getToken() }
            }).then((res) => {
                let supervisoryData = res.data.supervisorio

                setDadosPlantaBaixa(res.data.supervisorio_planta)

                try {
                    let equipamentos = []
                    let link = {
                        hash: hash,
                        timezone: res.data.timezone,
                        expira: res.data.expira ? (res.data?.expira * 1000) : null
                    }

                    const widgets = JSON.parse(supervisoryData?.widgets)
                    widgets.forEach(widget => equipamentos.push(widget.equipamento))
                    equipamentos = Array.from(new Set(equipamentos))

                    let formData = new FormData()
                    formData.append("equipamentos", JSON.stringify(equipamentos))

                    axios({
                        url: url,
                        method: "POST",
                        data: formData,
                        headers: { 'Authorization': 'Bearer ' + auth.getToken() }
                    }).then((res) => {
                        let reportes = res.data ?? []

                        for (let key of Object.keys(reportes)) {
                            reportes[key].unidades = {}

                            if ("_parametros" in reportes[key]) {
                                reportes[key]._parametros?.forEach((param) => {
                                    if ("unidade" in param) {
                                        reportes[key].unidades[param.identificacao] = param.unidade
                                    }
                                })
                            }
                        }

                        supervisoryData["equipamentos"] = equipamentos
                        supervisoryData["reportes"] = reportes
                        link.supervisorio = supervisoryData
                        setLink(link)
                    })
                }
                catch (err) {
                    console.error(err)
                }
            })
        }
    }

    useEffect(() => checkHash(), [])

    return link.supervisorio ? <Supervisorio hash={props.match.params.hash} link={link} shared={true} dadosPlantaBaixa={dadosPlantaBaixa} /> : null
}

export { Supervisorio, SupervisorioLink }